<template>
  <!-- 系统整体页面布局 -->
  <el-container class="el-container">
    <!-- 页面头部区域 高度默认60px -->
    <el-header :class="$store.getters.showHeader == true ? 'el-header' : 'el-header1'">
      <div :style="{

        display: $store.getters.showHeader == true ? 'block' : 'none',
      }">
        <img style="width: 95px; height:25px;float: left; " src="../assets/LOGO_1.png" />
        <!-- <div class="contract">
          <i @click="contractEvt(2)" v-if="contractNum == 1" class="el-icon-s-unfold"></i>
          <i @click="contractEvt(1)" v-else class="el-icon-s-fold"></i>
        </div> -->
      </div>
      <div class="headerMenu" :style="{ display: $store.getters.showHeader == true ? 'block' : 'none' }">
        <el-menu class="el-menu-demo" mode="horizontal" :default-active="activeIndex" @select="topMenuEvt">
          <el-menu-item index="1">参考图</el-menu-item>
          <el-menu-item index="2">模型</el-menu-item>
          <el-menu-item index="3">PS素材</el-menu-item>
          <el-menu-item index="4">用户</el-menu-item>
          <el-menu-item index="7">标签</el-menu-item>
          <el-menu-item index="5">收入</el-menu-item>
          <el-menu-item index="6">搜索</el-menu-item>
          <el-menu-item index="8">AI</el-menu-item>
          <el-menu-item index="9">工具</el-menu-item>
        </el-menu>
      </div>
      <div :style="{ display: $store.getters.showHeader == true ? 'block' : 'none' }"
        style="position: absolute;right: 20px;">
        <el-dropdown @command="outLoginEvt">
          <span class="el-dropdown-link">
            <el-avatar src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"></el-avatar>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="1">退出登陆</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-header>
    <el-container>
      <!-- 左侧菜单栏部分 -->
      <el-aside v-if="contractNum == 1" class="el-aside">
        <el-scrollbar class="menu_scroll" style="height: 100vh;">
          <div>
            <el-input placeholder="搜索" v-model="filterText" class="menus_input" @input="onFilter"></el-input>
            <el-tree class="filter-tree" :data="menuItems" :filter-node-method="filterNode" node-key="id" ref="tree"
              accordion style="margin-top: 10px;" :default-expanded-keys="['全部']" highlight-current
              @current-change="handleCurrentChange_evt">
              <div class="custom-tree-node" slot-scope="{ node }">
                <span>{{ node.data.name }}</span>
                <span  :style="{ color: String(node.data.num) === '0' ? '#e3e3e3' : '' }">{{ String(node.data.num) }}</span>
              </div>
            </el-tree>
          </div>
        </el-scrollbar>
      </el-aside>
      <!-- 右侧主题页面内容展示 -->
      <el-main class="el-mian">
        <div v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.8)">
          <!-- 头部搜索分页盒子开始 -->
          <div :class="header == true ? 'search-box' : 'search-box1'"
            :style="{ width: $store.getters.contractNum == 2 ? '100%' : '' }">
            <div>
              <div style="display: flex;">
                <span @click="cleanUpEvt" class="all_text" style="height: 26px;margin-top: 10px;"
                  v-if="hasContent">All</span>
                <div @click="dialogVisible_one = true"
                  style=" margin-top: 13px; line-height: 26px;  width: 80px;height: 26px;cursor: pointer;display: flex; border:1px solid #b3b7bc;margin-left:10px;justify-content: center;border-radius: 5px;margin-right: 10px;">
                  <span style="font-size: 13px;color:#787373">Filter</span>
                </div>
                <div style="min-width: 850px;display: flex;flex-wrap: wrap;height: 70px;" class="width_ect">
                  <el-input v-if="checkInput" v-model="checkInput" style="width: 120px;margin-top:5px;margin-left:5px"
                    size="mini" @focus="searchLabel1Evt" placeholder="标签查询" clearable @clear="clearEvt1"
                    :class="checkInput == '' ? 'blue' : 'orange'" class="border_box_e"></el-input>

                  <el-input v-if="frontOrderInput" v-model="frontOrderInput"
                    style="width: 120px;margin-top:13px;margin-left:5px" size="mini" @focus="focusDiyIptEvt"
                    placeholder="ID查询" clearable @clear="clearEvt2" :class="frontOrderInput == '' ? 'blue' : 'orange'"
                    class="border_box_e" @change="selectImg()"></el-input>

                  <el-input v-if="authorInput" v-model="authorInput" style="width: 120px;margin-top:13px;margin-left:5px"
                    size="mini" placeholder="选择作者" @focus="focusDiyIptEvt" clearable
                    :class="authorInput == '' ? 'blue' : 'orange'" class="border_box_e"
                    @change="selectImg()"></el-input>

                  <el-input v-if="zhuShi" v-model="zhuShi" style="width: 120px;margin-top:13px;margin-left:5px"
                    size="mini" placeholder="选择作者" @focus="focusDiyIptEvt" clearable
                    :class="zhuShi == '' ? 'blue' : 'orange'" class="border_box_e" @change="selectImg()"></el-input>

                  <el-date-picker v-if="value2 && value2.length" v-model="value2"
                    style="width: 240px;margin-top:13px;margin-left:5px" type="daterange" :picker-options="pickerOptions"
                    size="mini" format="yyyy-MM-dd" value-format="yyyyMMdd" range-separator="" class="border_box_e"
                    start-placeholder="添加时间" end-placeholder="结束时间" align="right"
                    :class="{ 'your-css-class': !isValue2Empty }" @change="selectImg()">
                  </el-date-picker>

                  <el-date-picker v-if="value1 && value1.length" v-model="value1"
                    style="width: 240px;margin-top:13px;margin-left:5px" type="daterange" :picker-options="pickerOptions"
                    size="mini" format="yyyy-MM-dd" value-format="yyyyMMdd" range-separator="" class="border_box_e"
                    start-placeholder="添加时间" end-placeholder="结束时间" align="right"
                    :class="{ 'your-css-class': !isValue1Empty }" @change="selectImg()">
                  </el-date-picker>
                  <el-date-picker v-if="value3 && value3.length" v-model="value3"
                    style="width: 240px;margin-top:13px;margin-left:5px" type="daterange" :picker-options="pickerOptions"
                    size="mini" format="yyyy-MM-dd" value-format="yyyyMMdd" range-separator="" class="border_box_e"
                    start-placeholder="添加时间" end-placeholder="结束时间" align="right"
                    :class="{ 'your-css-class': !isValue3Empty }" @change="selectImg()">
                  </el-date-picker>
                  <el-date-picker v-if="value4 && value4.length" v-model="value4"
                    style="width: 240px;margin-top:13px;margin-left:5px" type="daterange" :picker-options="pickerOptions"
                    size="mini" format="yyyy-MM-dd" value-format="yyyyMMdd" range-separator="" class="border_box_e"
                    align="right" :class="{ 'your-css-class': !isValue4Empty }" @change="selectImg()">
                  </el-date-picker>

                  <SizePopover style="margin-top:13px;margin-left:5px"
                    v-if="Object.keys(sizeRange_1) && Object.keys(sizeRange_1).length" class="size_ect"
                    :class="Object.keys(sizeRange_1).length ? 'orange' : 'blue'" @save="handleSave"
                    v-model="sizeRange_1" @clear="handleClear" ref="sizePopover1" />


                  <compress-size-input class="all_input_e" v-if="compressSize" label="" placeholder="请输入范围"
                    v-model="compressSize" :class="compressSize == '' ? 'blue' : 'orange'"
                    @update="handleUpdate('compressSize', $event)"></compress-size-input>

                  <compress-size-input class="all_input_e" v-if="MAX_daxiao" v-model="MAX_daxiao"
                    @update="handleUpdate('MAX_daxiao', $event)" label="" :class="MAX_daxiao == '' ? 'blue' : 'orange'"
                    placeholder="请输入范围"></compress-size-input>

                  <el-select v-if="baoMi" class="border_box_e" v-model="baoMi"
                    style="width:120px;height: 28px;border:1px solid;margin-top:13px;margin-left:5px" clearable
                    @change="baoMi_e" :class="baoMi == '' ? 'blue' : 'orange'">
                    <el-option v-for="(option, index) in options2" :key="index" :label="option.label"
                      :value="option.value" style=" width:120px;height: 40px;">
                    </el-option>
                  </el-select>

                  <el-select v-if="pinFen" class="border_box_e" :class="pinFen == '' ? 'blue' : 'orange'"
                    v-model="pinFen" style="width:120px;height: 28px;border:1px solid;;margin-top:13px;margin-left:5px"
                    clearable @change="pinFen_e">
                    <el-option v-for="(option, index) in options3" :key="index" :label="option.label"
                      :value="option.value">
                    </el-option>
                  </el-select>
                  <compress-size-input v-if="xiazai_shu" class="all_input_e"
                    :class="xiazai_shu == '' ? 'blue' : 'orange'" v-model="xiazai_shu"
                    @update="handleUpdate('xiazai_shu', $event)" label="" placeholder="请输入范围"></compress-size-input>

                  <compress-size-input v-if="chaKan_shu" class="all_input_e"
                    :class="chaKan_shu == '' ? 'blue' : 'orange'" v-model="chaKan_shu"
                    @update="handleUpdate('chaKan_shu', $event)" label="" placeholder="请输入范围"></compress-size-input>

                  <el-input v-if="shouJia" class="border_box_e" placeholder="请输入范围" clearable v-model="shouJia"
                    style="width: 120px;;margin-top:13px;margin-left:5px" size="mini"
                    :class="shouJia == '' ? 'blue' : 'orange'" @change="selectImg()">
                  </el-input>
                  <el-input v-if="xiaoShouE" class="border_box_e" placeholder="请输入范围" cla ss="border_box_e" clearable
                    v-model="xiaoShouE" style="width: 120px;;margin-top:13px;margin-left:5px"
                    :class="xiaoShouE == '' ? 'blue' : 'orange'" @change="selectImg()">
                  </el-input>
                  <el-select v-if="banBen" class="border_box_e" v-model="banBen"
                    style="width:120px;height: 28px;border:1px solid;;margin-top:13px;margin-left:5px" clearable
                    @change="banBen_e" :class="banBen == '' ? 'blue' : 'orange'">
                    <el-option v-for="(option, index) in options7" :key="index" :label="option.label"
                      :value="option.label">
                    </el-option>
                  </el-select>
                  <el-select v-if="dengGuang" class="border_box_e" :class="dengGuang == '' ? 'blue' : 'orange'"
                    v-model="dengGuang"
                    style="width:120px;height: 28px;border:1px solid;;margin-top:13px;margin-left:5px" clearable
                    @change="dengGuang_e">
                    <el-option v-for="(option, index) in options4" :key="index" :label="option.label"
                      :value="option.value">
                    </el-option>
                  </el-select>
                  <el-select v-if="xiangJi" class="border_box_e" :class="xiangJi == '' ? 'blue' : 'orange'"
                    v-model="xiangJi" style="width:120px;height: 28px;border:1px solid;;margin-top:13px;margin-left:5px"
                    clearable @change="xiangJi_e">
                    <el-option v-for="(option, index) in options5" :key="index" :label="option.label"
                      :value="option.value" style=" width:160px;height: 40px;">
                    </el-option>
                  </el-select>

                  <el-select v-if="xuanRan" class="border_box_e" :class="xuanRan == '' ? 'blue' : 'orange'"
                    v-model="xuanRan" style="width:120px;height: 28px;border:1px solid;;margin-top:13px;margin-left:5px"
                    clearable @change="xuanRan_e">
                    <el-option v-for="(option, index) in options8" :key="index" :label="option.label"
                      :value="option.value" style=" width:160px;height: 40px;">
                    </el-option>
                  </el-select>
                  <el-select v-if="senLin" class="border_box_e" :class="senLin == '' ? 'blue' : 'orange'"
                    v-model="senLin" style="width:120px;height: 28px;border:1px solid;margin-top:13px;margin-left:5px"
                    clearable @change="senLin_e">
                    <el-option v-for="(option, index) in options6" :key="index" :label="option.label"
                      :value="option.value" style=" width:160px;height: 40px;">
                    </el-option>
                  </el-select>
                  <compress-size-input v-if="Maps_da" class="all_input_e" :class="Maps_da == '' ? 'blue' : 'orange'"
                    v-model="Maps_da" @update="handleUpdate('Maps_da', $event)" label=""
                    placeholder="请输入范围"></compress-size-input>
                  <compress-size-input v-if="Maps_shu" class="all_input_e" :class="Maps_shu == '' ? 'blue' : 'orange'"
                    v-model="Maps_shu" @update="handleUpdate('Maps_shu', $event)" label=""
                    placeholder="请输入范围"></compress-size-input>
                  <compress-size-input v-if="object_shu" class="all_input_e"
                    :class="object_shu == '' ? 'blue' : 'orange'" v-model="object_shu"
                    @update="handleUpdate('object_shu', $event)" label="" placeholder="请输入范围"></compress-size-input>
                  <compress-size-input v-if="shuCai_shu" class="all_input_e"
                    :class="shuCai_shu == '' ? 'blue' : 'orange'" v-model="shuCai_shu"
                    @update="handleUpdate('shuCai_shu', $event)" label="" placeholder="请输入范围"></compress-size-input>
                  <compress-size-input v-if="dingDian_shu" class="all_input_e"
                    :class="dingDian_shu == '' ? 'blue' : 'orange'" v-model="dingDian_shu"
                    @update="handleUpdate('dingDian_shu', $event)" label="" placeholder="请输入范围"></compress-size-input>

                  <el-select class="border_box_e" v-if="design" v-model="design"
                    :class="design == '' ? 'blue' : 'orange'"
                    style="width:120px;height: 28px;border:1px solid;margin-top:13px;margin-left:5px" clearable
                    @change="type_one">
                    <el-option v-for="(option, index) in options1" :key="index" :label="option.label"
                      :value="option.value" style=" width:160px;height: 40px;">
                    </el-option>
                  </el-select>
                </div>
              </div>


              <!-- <div :style="{ display: $store.getters.process == 3 ? '' : 'none' }" class="caoz">
                <el-input v-model="operateLabelInput" style="width: 120px; margin-left: 10px;margin-top: -2px;"
                  size="mini" @focus="searchLabelEvt" placeholder="标签操作"
                  :class="operateLabelInput == '' ? 'blue' : 'orange'" class="border_box"></el-input>
                <el-checkbox-group v-model="radio" @change="checkboxEvt" v-if="operateNum.show == true">
                  <el-checkbox style="margin-right: 70px" label="1">全部{{ operateNum.all }}</el-checkbox>
                  <el-checkbox label="2">未审阅{{ operateNum.not_review }}</el-checkbox>
                  <el-checkbox label="3">属于{{ operateNum.belong }}</el-checkbox>
                  <el-checkbox label="4">不属于{{ operateNum.not_belong }}</el-checkbox>
                </el-checkbox-group>
              </div> -->
            </div>
            <!-- 头部搜索分页结束 -->
            <div class="block">
              <div class="pagination_box">
                <el-input v-model="paginationInput" style="width: 50px" size="mini" @change="limitEvt"
                  placeholder="请输入本页显示"></el-input>
                <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage1"
                  :page-size="paginationInput - 0" layout="prev, pager, next, jumper" :total="total" :pager-count="5"
                  :show-total="showTotal">
                </el-pagination>

                <div class="all-box" style="margin: 0px 10px ;">
                  <el-button type="primary" size="mini" @click="selectAllEvt" style="width: 78px"
                    :style="{ backgroundColor: selectAllBgColor }">{{ selectAllText }}</el-button>
                  <span> &nbsp; 已选中 </span>
                  <span>：{{ selectArr.length }} </span>
                </div>
                <div style="display: flex;align-items: center;">
                  <!-- <el-button type="primary" @click="uploadEvt" size="mini">上传素材</el-button> -->
                  <el-button type="info" @click="delete_Pop" size="mini">删除</el-button>

                  <el-dropdown :hide-on-click="false" @command="sortEvt">
                    <span class="el-dropdown-link select_e">
                      {{ sortName }}<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="9" :disabled="sort == 9 ? true : false">收藏最多</el-dropdown-item>
                      <el-dropdown-item command="7" :disabled="sort == 7 ? true : false">下载次数最多</el-dropdown-item>
                      <el-dropdown-item command="1" :disabled="sort == 1 ? true : false">上传时间-升序</el-dropdown-item>
                      <el-dropdown-item command="2" :disabled="sort == 2 ? true : false">上传时间-降序</el-dropdown-item>
                      <el-dropdown-item command="3" :disabled="sort == 3 ? true : false">文件大小-升序</el-dropdown-item>
                      <el-dropdown-item command="4" :disabled="sort == 4 ? true : false">文件大小-降序</el-dropdown-item>
                      <el-dropdown-item command="5" :disabled="sort == 5 ? true : false">文件尺寸-升序</el-dropdown-item>
                      <el-dropdown-item command="6" :disabled="sort == 6 ? true : false">文件尺寸-降序</el-dropdown-item>
                      <el-dropdown-item command="8" :disabled="sort == 8 ? true : false">点击查看次数最多</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>

                  <div class="dropdown-container" style="width: 80px;cursor: pointer;height: 30px;display: flex;"
                    @click="toggleDropdown">
                    <!-- 下拉菜单触发按钮 -->
                    <div class="dropdown-trigger">
                      <img :src="currentImageSrc" style="width: 20px; height: 20px; cursor: pointer;" />
                      <div class="arrow-icon"></div>
                    </div>

                    <!-- 下拉菜单 -->
                    <div v-if="isDropdownVisible" class="dropdown-menu">
                      <div v-for="(image, index) in images" :key="index" @click="selectImage(image)" class="menu-item">
                        <img :src="image.src" style="width: 20px; height: 20px; cursor: pointer;" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>


            </div>
          </div>

          <!-- 图片盒子开始 -->
          <el-scrollbar>
            <div class="img-box" v-if="changing !== 3"
              :style="{ width: $store.getters.contractNum == 2 ? '100%' : '' }">
              <div class="flex-images" @scroll="imgScrollEvt">
                <div class="item" v-for="(e, index) in imgArr" :key="index" :data-w="changing == 1 ? '503' : e.width"
                  :data-h="changing == 1 ? '360' : e.height" @mousemove="mousemoveEvt(e)" @mouseout="mouseoutEvt"
                  @click.stop="imgEvt(e, index)" @contextmenu.prevent="rightClickEvt">
                  <img :src="e.cover" />

                  <div class="select" :style="{ display: e.select == true ? 'block' : 'none' }">
                    <i class="el-icon-check"></i>
                  </div>
                  <el-popover :style="{ display: e.select == true ? 'block' : 'none' }" class="operation_box"
                    placement="right-start" width="230" trigger="manual" v-model="e.leftSelect">
                    <div class="operation_center">
                      <div class="center_box" v-for="res in operationArr" :key="res.id">
                        <span>{{ res.title }}</span>
                        <el-checkbox-group class="check_min" v-model="res.selectArr" @change="checkbox1Evt(res)"
                          v-for="j in res.children" :key="j.id">
                          <el-checkbox :label="j.id">{{ j.title }}</el-checkbox>
                        </el-checkbox-group>
                      </div>
                      <div class="btn_box">
                        <el-button size="mini" ref="coverCancel" @click="cancelEvt(e)">取消</el-button>
                        <el-button type="primary" @click="changeImgEvt(e)" size="mini">确定</el-button>
                      </div>
                    </div>
                    <el-button slot="reference" @click.stop="leftSelectEvt(e)" icon="el-icon-s-operation"></el-button>
                  </el-popover>

                  <span class="id_text" v-if="e.source_id == mousemoveId">id:{{ e.source_id }}</span>

                  <div class="bottom_text">
                    <div></div>
                    <div>
                      <!-- <span v-if="favorite !==9&&review !==8">下载次数:{{ e.download_num }}</span>
                          <span v-else-if="review ==8">查看次数:{{ e.review }}</span>
                          <span v-else-if="favorite ==9">收藏次数:{{ e.favorite }}</span> -->
                      <b v-if="operateNum.show == true"></b>
                      <i v-if="operateNum.show == true && e.status == 0" style="background-color: green"></i>
                      <i v-else-if="operateNum.show == true && e.status == 1" style="background-color: #f00"></i>
                      <i v-else-if="operateNum.show == true && e.status == 3"></i>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <div style="height:65px;padding: 10px;"></div>

          </el-scrollbar>
          <!-- 图片盒子结束 -->
          <!-- 空格弹窗开始 -->

          <!-- 空格弹窗结束 -->

          <!-- 标签操作弹窗开始 -->
          <el-dialog title="" :visible.sync="searchLabelDialog" width="51%" custom-class="searchLabel"
            :show-close="false" @open="searchDialogEvt">
            <div style="width: 90%; height: 100%">
              <div class="space" style="float: left; margin-left: 20px">
                <div class="check">
                  <div v-for="item in labelArr" :key="item.id">
                    <p>{{ item.title }}</p>
                    <div class="checkbox" v-for="e in item.children" :key="e.id" @click="labelSearchEvt(e)">
                      <i></i>
                      <b v-if="e.status == 3"></b>
                      <b v-else-if="e.status == 0" style="background-color: green"></b>
                      <b v-else-if="e.status == 1" style="background-color: #f00"></b>
                      <b v-else-if="e.status == 2" style="background-color: #999"></b>
                      <span class="space_title" :style="{
                        backgroundColor: e.finish == 1 ? '#e5e5e5' : 'none',
                        padding: '4px',
                      }">{{ e.title }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-dialog>
          <!-- 标签操作弹窗结束 -->
          <!-- <SearchLabel :searchFor="searchFor" @cancel="cancel" :process="process" @revise="revise" :type="type"
            @reviseText="reviseText" :author="authorInput" :time="value2" :frontOrder="frontOrderInput"
            :operateLabelInput="operateLabelInput" :labelId="labelId" :checkInput="checkInput" /> -->

          <!-- 右键弹窗开始 -->
          <el-dialog title="" :visible.sync="rightLabelDialog" width="51%" custom-class="searchLabel"
            :show-close="false" @close="closeEvt" @open="rightDialogEvt">
            <div style="width: 90%; height: 580px">
              <div class="space" style="float: left; margin-left: 20px">
                <div class="check">
                  <div v-for="item in labelArr" :key="item.id">
                    <p :style="{ color: item.one == true ? '#409EFF' : '#595959' }">
                      {{ item.title }}
                    </p>
                    <div class="checkbox" v-for="e in item.children" :key="e.id" @click.stop="searchLabEvt(e)">
                      <i @click.stop="colorEvt(e)"></i>
                      <b @click.stop="colorEvt(e)" v-if="e.status == 3"></b>
                      <b @click.stop="colorEvt(e)" v-else-if="e.status == 0" style="background-color: green"></b>
                      <b @click.stop="colorEvt(e)" v-else-if="e.status == 1"
                        style="background-color: rgb(249, 157, 157)"></b>
                      <b @click.stop="colorEvt(e)" v-else-if="e.status == 2" style="background-color: #d1d1d1"></b>
                      <span :style="{
                        color:
                          e.status == 0
                            ? '#333'
                            : e.status == 1
                              ? '#d0d0d0'
                              : e.status == 2
                                ? '#d0d0d0'
                                : e.status == 3
                                  ? '#000'
                                  : '',
                        'font-weight': e.status == 0 ? '400' : '',
                      }">{{ e.title }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="rightSearch">已选中:{{ selectArr.length }}</div>
            <span slot="footer" class="dialog-footer">
              <el-button size="small" @click="rightLabelDialog = false">取 消</el-button>
              <el-button size="small" type="primary" @click="submitRightLabelEvt">确 定</el-button>
            </span>
          </el-dialog>
          <!-- 右键弹窗结束 -->

          <el-dialog title="提示" :visible.sync="deleteVisible" width="30%" :before-close="handleClose">
            <span style="font-size: 14px">
              {{
              $store.getters.process == 5
              ? "此操作将文件永久删除, 是否继续?"
              : "此操作将文件放进回收站, 是否继续?"
              }}</span>
            <span slot="footer" class="dialog-footer">
              <el-button @click="deleteVisible = false">取 消</el-button>
              <el-button type="primary" @click="deleteEvt">确 定</el-button>
            </span>
          </el-dialog>

          <el-dialog :visible.sync="dialogVisible_one" width="1400" custom-class="sousuo" :show-close="false">
            <div style="height:360px;">
              <span
                style="width: 69px;border: 1px solid #589ff9;height: 26px;font-size: 12px;line-height: 26px;color: #589ff9;border-radius: 3px;cursor: pointer;display: flex;justify-content: center;margin: 0px 40px 30px 80px;"
                @click="cleanUpEvt">ALL</span>
              <div style="height:300px;display:flex">
                <div>
                  <div class="all_input">
                    <span>ID</span>
                    <el-input v-model="frontOrderInput" style="width: 160px;" size="mini" placeholder="ID查询" clearable
                      :class="frontOrderInput == '' ? 'blue' : 'orange'" class="border_box" @change="selectImg()">
                    </el-input>
                  </div>
                  <div class="all_input">
                    <span>作者</span>
                    <el-input v-model="authorInput" size="mini" placeholder="请输入" clearable
                      :class="authorInput == '' ? 'blue' : 'orange'" class="border_box" @change="selectImg()">
                    </el-input>
                  </div>
                  <div class="all_input">
                    <span>注释</span>
                    <el-input v-model="zhuShi" size="mini" placeholder="请输入" clearable
                      :class="zhuShi == '' ? 'blue' : 'orange'" class="border_box" @change="selectImg()">
                    </el-input>
                  </div>
                </div>
                <div>
                  <div class="all_input">
                    <span>添加时间</span>
                    <el-date-picker style="width: 180px;height: 40px; margin-left: 6px;" v-model="value2"
                      type="daterange" :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd"
                      value-format="yyyyMMdd" range-separator="" class="border_box" start-placeholder="添加时间"
                      end-placeholder="结束时间" align="right" :class="{ 'your-css-class': !isValue2Empty }"
                      @change="selectImg()">
                    </el-date-picker>
                  </div>
                  <div class="all_input">
                    <span>修改时间</span>
                    <el-date-picker v-model="value1" style="width: 180px;height: 40px; margin-left: 6px;"
                      type="daterange" :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd"
                      range-separator="" class="border_box" start-placeholder="修改时间" end-placeholder="结束时间"
                      align="right" value-format="timestamp" :class="{ 'your-css-class': !isValue1Empty }"
                      @change="selectImg()">
                    </el-date-picker>
                  </div>
                  <div class="all_input">
                    <span>下载时间</span>
                    <el-date-picker v-model="value3" style="width: 180px;height: 40px; margin-left: 6px;"
                      type="daterange" :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd"
                      range-separator="" class="border_box" start-placeholder="修改时间" end-placeholder="结束时间"
                      align="right" value-format="timestamp" :class="{ 'your-css-class': !isValue3Empty }"
                      @change="selectImg()">
                    </el-date-picker>
                  </div>
                  <div class="all_input">
                    <span>查看时间</span>
                    <el-date-picker v-model="value4" style="width: 180px;height: 40px; margin-left: 6px;"
                      type="daterange" :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd"
                      range-separator="" class="border_box" start-placeholder="查看时间" align="right"
                      end-placeholder="结束时间" value-format="timestamp" :class="{ 'your-css-class': !isValue4Empty }"
                      @change="selectImg()">
                    </el-date-picker>
                  </div>
                </div>
                <div>
                  <div class="all_input">
                    <span>封面尺寸</span>
                    <SizePopover :class="Object.keys(sizeRange_1).length ? 'orange' : 'blue'" ref="sizePopover2"
                      @save="handleSave" v-model="sizeRange_1" @clear="handleClear" />
                  </div>
                  <div>
                    <compress-size-input label="压缩包大小" placeholder="请输入范围" v-model="compressSize"
                      :class="compressSize == '' ? 'blue' : 'orange'" ref="compressPopover1"
                      @update="handleUpdate('compressSize', $event)"></compress-size-input>
                  </div>
                  <div>
                    <compress-size-input v-model="MAX_daxiao" @update="handleUpdate('MAX_daxiao', $event)" label="MAX大小"
                      ref="compressPopover2" :class="MAX_daxiao == '' ? 'blue' : 'orange'"
                      placeholder="请输入范围"></compress-size-input>
                  </div>
                </div>
                <div>
                  <div class="all_input">
                    <span>保密</span>
                    <el-select v-model="baoMi" style="width:160px;height: 40px;" clearable @change="baoMi_e"
                      :class="baoMi == '' ? 'blue' : 'orange'">
                      <el-option v-for="(option, index) in options2" :key="index" :label="option.label"
                        :value="option.value" style=" width:160px;height: 40px;">
                      </el-option>
                    </el-select>
                  </div>
                  <div class="all_input">
                    <span>评分</span>
                    <el-select :class="pinFen == '' ? 'blue' : 'orange'" v-model="pinFen"
                      style="width:160px;height: 40px;" clearable @change="pinFen_e">
                      <el-option v-for="(option, index) in options3" :key="index" :label="option.label"
                        :value="option.value" style=" width:160px;height: 40px;">
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div>
                  <div>
                    <compress-size-input :class="xiazai_shu == '' ? 'blue' : 'orange'" v-model="xiazai_shu"
                      @update="handleUpdate('xiazai_shu', $event)" label="下载数量" ref="compressPopover3"
                      placeholder="请输入范围"></compress-size-input>
                  </div>
                  <div>
                    <compress-size-input :class="chaKan_shu == '' ? 'blue' : 'orange'" v-model="chaKan_shu"
                      @update="handleUpdate('chaKan_shu', $event)" label="查看数量" ref="compressPopover4"
                      placeholder="请输入范围"></compress-size-input>
                  </div>
                  <div class="all_input">
                    <span>售价</span>
                    <el-input clearable v-model="shouJia" :class="shouJia == '' ? 'blue' : 'orange'"
                      @change="selectImg()">
                    </el-input>
                  </div>
                  <div class="all_input">
                    <span>总销售额</span>
                    <el-input clearable v-model="xiaoShouE" :class="xiaoShouE == '' ? 'blue' : 'orange'"
                      @change="selectImg()">
                    </el-input>
                  </div>
                </div>
                <div>
                  <div class="all_input">
                    <span>文件版本</span>
                    <el-select v-model="banBen" style="width:160px;height: 40px;" clearable @change="banBen_e"
                      :class="banBen == '' ? 'blue' : 'orange'">
                      <el-option v-for="(option, index) in options7" :key="index" :label="option.label"
                        :value="option.label" style=" width:160px;height: 40px;">
                      </el-option>
                    </el-select>
                  </div>
                  <div class="all_input">
                    <span>灯光</span>
                    <el-select :class="dengGuang == '' ? 'blue' : 'orange'" v-model="dengGuang"
                      style="width:160px;height: 40px;" clearable @change="dengGuang_e">
                      <el-option v-for="(option, index) in options4" :key="index" :label="option.label"
                        :value="option.value" style=" width:160px;height: 40px;">
                      </el-option>
                    </el-select>
                  </div>
                  <div class="all_input">
                    <span>相机</span>
                    <el-select :class="xiangJi == '' ? 'blue' : 'orange'" v-model="xiangJi"
                      style="width:160px;height: 40px;" clearable @change="xiangJi_e">
                      <el-option v-for="(option, index) in options5" :key="index" :label="option.label"
                        :value="option.value" style=" width:160px;height: 40px;">
                      </el-option>
                    </el-select>
                  </div>
                  <div class="all_input">
                    <span>渲染器</span>
                    <el-select :class="xuanRan == '' ? 'blue' : 'orange'" v-model="xuanRan"
                      style="width:160px;height: 40px;" clearable @change="xuanRan_e">
                      <el-option v-for="(option, index) in options8" :key="index" :label="option.label"
                        :value="option.value" style=" width:160px;height: 40px;">
                      </el-option>
                    </el-select>
                  </div>
                  <div class="all_input">
                    <span>森林</span>
                    <el-select :class="senLin == '' ? 'blue' : 'orange'" v-model="senLin"
                      style="width:160px;height: 40px;" clearable @change="senLin_e">
                      <el-option v-for="(option, index) in options6" :key="index" :label="option.label"
                        :value="option.value" style=" width:160px;height: 40px;">
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div>
                  <div>
                    <compress-size-input :class="Maps_da == '' ? 'blue' : 'orange'" v-model="Maps_da"
                      ref="compressPopover5" @update="handleUpdate('Maps_da', $event)" label="贴图大小"
                      placeholder="请输入范围"></compress-size-input>
                  </div>
                  <div>
                    <compress-size-input :class="Maps_shu == '' ? 'blue' : 'orange'" v-model="Maps_shu"
                      ref="compressPopover6" @update="handleUpdate('Maps_shu', $event)" label="贴图数量"
                      placeholder="请输入范围"></compress-size-input>
                  </div>
                  <div>
                    <compress-size-input :class="object_shu == '' ? 'blue' : 'orange'" v-model="object_shu"
                      @update="handleUpdate('object_shu', $event)" label="物体数量" ref="compressPopover7"
                      placeholder="请输入范围"></compress-size-input>
                  </div>
                  <div>
                    <compress-size-input :class="shuCai_shu == '' ? 'blue' : 'orange'" v-model="shuCai_shu"
                      @update="handleUpdate('shuCai_shu', $event)" label="素材面数" ref="compressPopover8"
                      placeholder="请输入范围"></compress-size-input>
                  </div>
                  <div>
                    <compress-size-input :class="dingDian_shu == '' ? 'blue' : 'orange'" v-model="dingDian_shu"
                      @update="handleUpdate('dingDian_shu', $event)" label="顶点数" ref="compressPopover9"
                      placeholder="请输入范围"></compress-size-input>
                  </div>
                  <div class="all_input">
                    <span>样条线</span>
                    <el-select v-model="design" :class="design == '' ? 'blue' : 'orange'"
                      style="width:160px;height: 40px;" clearable @change="type_one">
                      <el-option v-for="(option, index) in options1" :key="index" :label="option.label"
                        :value="option.value" style=" width:160px;height: 40px;">
                      </el-option>
                    </el-select>
                  </div>
                </div>

              </div>
            </div>
          </el-dialog>

          <!-- 文件上传开始 -->
          <el-dialog title="上传参考" :visible.sync="uploadVisible" width="90%" :close-on-press-escape="true"
            :destroy-on-close="true">
            <Upload />

            <span slot="footer" class="dialog-footer"> </span>
          </el-dialog>

          <SpaceDialog_e :visible="dialogVisible" :data="imgArr" :active-index="activeIndex_copy"
            @update:visible="val => (dialogVisible = val)" before-close="clone_s" />

          <!-- 文件上传结束 -->
          <List v-if="changing == 3" :data="imgArr" :num="listNum" @Min_BOX="Min_BOX" ref="listComponent" />
        </div>
      </el-main>
    </el-container>

    <div v-if="$store.getters.coverShow == true" @click="coverEvt" class="cover_box"></div>
  </el-container>
</template>

<script>
import { outLoginApi } from "../apis/loginApi";
import "../backHome/js/flex-images"
import {
  getLabelApi,
  // getModelImgLabelApi,
  spaceDataSubmitApi,
} from "../apis/ces/a";
import {
  contentApi,
  changeModeImgApi,
  getModelLabelApi,
  getModelImgLabelApi,
  stickLabelApi,
  rightStickLabelApi,
  singleLabelApi,
  fingerboardNumApi,
  changeImgApi,
  showApi,
  deleteApi,
  modeltagApi
} from "../apis/mode";


import SpaceDialog_e from "@/components/SpaceDialog_e.vue";
import SizePopover from "@/components/SizePopover.vue";
import CompressSizeInput from '@/components/CompressSizeInput.vue';

// import SearchLabel from "@/components/SearchLabel.vue";
import List from "@/components/modeList.vue";
import Upload from "../upload/index.vue";
const delay = (function () {
  let timer = 0;
  return function (callback, ms) {
    clearTimeout(timer);
    timer = setTimeout(callback, ms);
  };
})();

export default {
  components: {
    // SearchLabel,
    Upload,
    List,
    SpaceDialog_e,
    CompressSizeInput,
    SizePopover
  },

  data() {
    return {
      circleUrl: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      //左侧菜单默认数据
      menuList: [
      ],
      //头部默认数据
      activeIndex: "2",

      sortName: "排序方式",
      uploadVisible: false,
      //查询数据
      checkInput: "",
      checkInputIs_tag: [],
      checkInputNot_tag: [],
      //序列前后数据
      behindOrderInput: "",
      frontOrderInput: "",

      //新增的数据
      zhuShi: '',
      value1: '',  //修改时间
      value3: "",//下载时间
      value4: '', //查看时间
      compressSize: '',
      sizeRange_1: {},
      MAX_daxiao: '',
      Maps_da: '',
      Maps_shu: '',
      object_shu: '',
      shuCai_shu: '',
      dingDian_shu: '',
      xiazai_shu: '',
      chaKan_shu: '',
      baoMi: '',
      pinFen: '',
      xiaoShouE: '',
      shouJia: '',
      dengGuang: '',
      xiangJi: '',
      senLin: '',
      banBen: '',
      xuanRan: '',

      activeIndex_copy: 0,

      //选择作者数据
      authorInput: "",
      //分页输入框数据
      paginationInput: null,
      //分页总数据
      total: null,
      //标签操作输入框数据
      operateLabelInput: "",
      //标签id
      labelId: "",
      //控制标签1 or 2请求
      labelAjax: false,
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本周",
            onClick(picker) {
              const current = new Date();
              let nowDayOfWeek = current.getDay();
              if (nowDayOfWeek === 0) nowDayOfWeek = 7;
              const dayNum = 1 * 24 * 60 * 60 * 1000;
              const firstDate = new Date(current.valueOf() - (nowDayOfWeek - 1) * dayNum);
              const lastDate = new Date(new Date(firstDate).valueOf() + 6 * dayNum);
              picker.$emit("pick", [firstDate, lastDate]);
            },
          },
          {
            text: "当月",
            onClick(picker) {
              const date = new Date();
              const year = date.getFullYear();
              const month = date.getMonth();
              let thisMonthStartDate = new Date(year, month, 1);
              let thisMonthEndDate = new Date(year, month + 1, 0);
              picker.$emit("pick", [thisMonthStartDate, thisMonthEndDate]);
            },
          },
          {
            text: "当年",
            onClick(picker) {
              var tYear = new Date().getFullYear();
              var startTime = new Date(tYear, 0, 1); //当前年第一天
              var endTime = new Date(tYear, 11, 31); //当前年最后一天
              picker.$emit("pick", [startTime, endTime]);
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit("pick", [start, start]);
            },
          },
          {
            text: "上周",
            onClick(picker) {
              const current = new Date(new Date().getTime() - 60 * 60 * 24 * 7 * 1000);
              let nowDayOfWeek = current.getDay();
              let diffToMonday =
                current.getDate() - nowDayOfWeek + (nowDayOfWeek === 0 ? -6 : 1);
              const firstDate = new Date(current.setDate(diffToMonday));
              const lastDate = new Date(current.setDate(diffToMonday + 6));
              picker.$emit("pick", [firstDate, lastDate]);
            },
          },
          {
            text: "上月",
            onClick(picker) {
              var now = new Date();
              var fd = new Date(now.getFullYear(), now.getMonth() - 1, 1);
              var ed = new Date(now.getFullYear(), now.getMonth(), 0);
              picker.$emit("pick", [fd, ed]);
            },
          },
          {
            text: "去年",
            onClick(picker) {
              var tYear = new Date().getFullYear() - 1;
              var startTime = new Date(tYear, 0, 1);
              var endTime = new Date(tYear, 11, 31); //当前年最后一天
              picker.$emit("pick", [startTime, endTime]);
            },
          },
        ],
      },
      filterText: '',
      menuItems: [],
      value2: "",


      input: "",
      //标签操作数据
      operateNum: {},
      // 滚动前，滚动条距文档顶部的距离
      oldScrollTop: 0,
      header: true,
      // 分页数据
      currentPage1: 1,
      //图片数据
      imgArr: [],
      // shift 案件数据
      shift: false,
      shiftFirst: false,
      //已选中图片数据
      selectArr: [],
      //空格弹窗
      dialogVisible: false,
      //空格弹窗标签数据
      spaceLabelArr: [],
      //空格弹窗当前页面数据
      spaceDialogNum: 0,
      //空格弹窗当前页面id
      spaceDialogId: [],
      //空格弹窗图片地址
      spaceSrc: "",
      //空格弹窗数据存储对象
      spaceObjData: {},
      //图片弹窗信息
      spaceImgInfo: {},
      //标签数据
      labelArr: [],
      //切换数据
      changing: sessionStorage.getItem('changing') || 1,
      //图片排版切换
      changingImg: false,
      //标签搜索弹窗数据
      searchLabelDialog: false,
      // 默认选中
      radio: ["1"],
      radioNum: ["1"],
      //右键弹窗数据
      rightLabelDialog: false,
      //弹出层
      operation: false,
      radio1: [""],
      operationArr: [],
      //当前页面状态
      process: "",
      type: 2,
      //图片左下弹窗显示状态
      visible: false,
      //搜索弹窗组件
      searchFor: false,
      //查看次数
      review: null,
      //收藏次数
      favorite: null,
      //排序数据
      sort: null,
      belongShow: null, //属于显示
      deleteVisible: false,
      loading: false,
      //空格弹窗图片数据（v之后）
      spaceWidth: "",
      spaceHeight: "",
      //空格弹窗图片数据（v之前）
      frontSpaceWidth: "",
      frontSpaceHeight: "",
      mousemoveId: "",
      selectAllText: "全选",
      selectAllBgColor: "#909399",
      pagefenye: false,

      num: null,
      listNum: null, //列表总数数据
      focusDiyIpt: false,
      orField: null,
      isValue2Empty: true,
      isValue1Empty: true,
      isValue3Empty: true,
      isValue4Empty: true,
      dialogVisible_one: false,


      activeName: '1',
      selectedStars: 0, // 当前选中的星星数量
      filledStar: require('../img/星星.png'), // 已选中星星的图标
      emptyStar: require('../img/星星 (1).png'), // 未选中星星的图标
      anNiu: false,

      tags: [
        { name: '标签一' },
        { name: '标签二' },
        { name: '标签三' },
        { name: '标签四' },
        { name: '标签五' }
      ],
      design: '',
      options1: [
        {
          value: '1',
          label: '无线条',
        }, {
          value: '2',
          label: '有线条',
        }],
      options2: [
        {
          value: '1',
          label: '保密',
        }, {
          value: '2',
          label: '不保密',
        }, {
          value: '3',
          label: '未审核',
        }],
      options3: [{
        value: '0',
        label: '未评分',
      },
      {
        value: '1',
        label: '1',
      }, {
        value: '2',
        label: '2',
      }, {
        value: '3',
        label: '3',
      }, {
        value: '4',
        label: '4',
      }, {
        value: '5',
        label: '5',
      }],
      options4: [{
        value: '1',
        label: '有灯光',
      },
      {
        value: '2',
        label: '无灯光',
      }],
      options5: [{
        value: '1',
        label: '有相机',
      },
      {
        value: '2',
        label: '无相机',
      }],
      options6: [{
        value: '1',
        label: '有森林',
      },
      {
        value: '2',
        label: '无森林',
      }],
      options7: [{
        label: '2017',
      },
      {
        label: '2020',
      },
      {
        label: '2023',
      }],
      options8: [{
        value: '1',
        label: 'VR',
      },
      {
        value: '2',
        label: 'CR',
        },
        {
          value: '3',
          label: '其他',
        }],

      sizeRange: '',

      isDropdownVisible: false, // 控制下拉菜单的显示与隐藏

      selectedNode: null, // 存储当前选中的节点
      currentImageSrc: require("@/img/2.png"), // 默认显示的图片
      images: [
        { num: 1, src: require("@/img/2.png") },
        { num: 2, src: require("@/img/3.png") },
        { num: 3, src: require("@/img/6.png") }
      ],
    }
  },
  created() {
    var arr = JSON.parse(JSON.stringify(this.$store.getters.menuList)).splice(0, 2)
    arr[0].selectArr = [`${arr[0].id}_${this.$store.getters.process}`]
    arr[1].selectArr = [`${arr[1].id}_${this.type}`]
    this.operationArr = arr

    let outdoor = JSON.parse(sessionStorage.getItem("outdoor"))
    if (outdoor) {
      this.authorInput = outdoor.select.author;
      (this.value2 = outdoor.select.time), (this.checkInput = outdoor.select.checkInput)
      this.radio = outdoor.select.radio;
      this.frontOrderInput = outdoor.select.source_id;
      this.sort = outdoor.select.sort;
      switch (outdoor.select.sort) {
        case "8":
          this.sortName = "点击查看次数最多";
          break;
        case "9":
          this.sortName = "收藏最多";
          break;
        case "1":
          this.sortName = "上传时间-升序";

          break;
        case "2":
          this.sortName = "上传时间-降序";

          break;
        case "3":
          this.sortName = "文件大小-升序";

          break;
        case "4":
          this.sortName = "文件大小-降序";

          break;
        case "5":
          this.sortName = "文件尺寸-升序";

          break;
        case "6":
          this.sortName = "文件尺寸-降序";

          break;
        case "7":
          this.sortName = "下载次数最多";

          break;
      }
      contentApi({
        type: this.type,
        process: this.$store.getters.process,
        is_tag: outdoor.select.is_tag,
        not_tag: outdoor.select.not_tag,
        author: outdoor.select.author,
        time: outdoor.select.time,
        tag_type: outdoor.select.radio[0],
        tag_id: outdoor.select.labelId,
        source_id: outdoor.select.source_id
      }).then((res) => {
        if (res.code == 1000) {
          this.imgArr = res.data.data
          this.total = res.data.total
          this.paginationInput = res.data.limit
          // this.changing = res.data.show
          
          this.sort = res.data.sort
          this.listNum = {
            download_num: res.data.download_num,
            order_time: res.data.order_time,
            order_total: res.data.order_total,
            total: res.data.total
          };
          if (outdoor.select.labelId) {
            this.labelId = outdoor.select.labelId
            this.operateLabelInput = outdoor.select.operateLabelInput
            var id = this.imgArr.map((res) => {
              return res.source_id
            })
            singleLabelApi({
              is_tag: outdoor.select.is_tag,
              not_tag: outdoor.select.not_tag,
              source_id: outdoor.select.source_id,
              author: outdoor.select.author,
              time: outdoor.select.time,
              tag_id: outdoor.select.labelId,
              type: this.type,
              process: this.$store.getters.process,
              source_ids: id
            }).then((val) => {
              if (val.code == 1000) {
                this.operateNum = val.data
                this.operateNum.show = true
                let arr = []
                this.imgArr.map((v) => {
                  val.data.refers.map((l) => {
                    if (v.source_id == l.source_id) {
                      v.status = l.status
                      arr.push(v)
                    }
                  })
                })
                this.imgArr = arr
              }
            })
          }
        }
      })
    } else {
      contentApi({
        type: this.type,
      }).then((res) => {
        if (res.code == 1000) {
          this.imgArr = res.data.data
          this.total = res.data.total
          this.paginationInput = res.data.limit
          this.sort = res.data.sort
          console.log(res,21321312);
          
          this.listNum = {
            download_num: res.data.download_num,
            order_time: res.data.order_time,
            order_total: res.data.order_total,
            total: res.data.total
          };
        }
      });
    }
    setTimeout(() => {
      modeltagApi().then((res) => {
        this.menuItems = this.transformToTree(res.data)
      });
    }, 300)
    // 默认选中“全部”节点
    this.$nextTick(() => {
      this.$refs.tree.setCurrentKey('all');
    });

    let chang = sessionStorage.getItem('changing') || 1;
    if (chang) {
      // 根据 changing 的值更新 currentImageSrc
      const selectedImage = this.images.find(image => image.num == this.changing);
      if (selectedImage) {
        this.changing = selectedImage.num
        this.currentImageSrc = selectedImage.src;
      }
    }
    //监听鼠标按下抬起事件
    window.addEventListener("keydown", this.handKeyCode, true)
    window.addEventListener("keyup", this.handKeyEvt, true)
  },
  mounted() {
    this.setDefaultSelectedNode();
    const location = this.$store.getters.location;
    window.addEventListener("scroll", (e) => this.imgScrollEvt(e), true);
    window.addEventListener('click', this.hideDropdownIfClickedOutside);
  },
  updated() {
    this.$nextTick(() => {
      new flexImages({
        selector: ".flex-images",
        rowHeight: 280,
      });
    });
  },
  beforeDestroy() {
    // 在组件生命周期结束的时候销毁
    window.removeEventListener("keydown", this.handKeyCode, false);
    window.removeEventListener("keyup", this.handKeyEvt, false);
    window.removeEventListener('click', this.hideDropdownIfClickedOutside);
  },
  computed: {

    contractNum: {
      get() {
        return this.$store.getters.contractNum;
      },
      set() { },
    },
    setSwitch: {
      get() {
        return this.$store.getters.setSwitch;
      },
    },
    coverShow() {
      return this.$store.getters.coverShow;
    },
    menu() {
      return this.$store.getters.process;
    },
    hasContent() {
      const fields = [
        this.checkInput,
        this.frontOrderInput,
        this.authorInput,
        this.value2
      ];
      // 检查所有字段的长度是否为0
      return fields.some(field => (field && (Array.isArray(field) ? field.length > 0 : field !== '')));
    },



  },

  watch: {
    inputCount(newVal) {
      console.log('inputCount changed:', newVal); // 监听 inputCount 的变化
    },
    coverShow(newV, oldV) {
      if (newV == false) {
        this.imgArr = this.imgArr.map((res) => {
          res.leftSelect = false;
          return res;
        });
      }
    },
    menu(newV, oldV) {
      contentApi({
        type: this.type,
        process: newV,
      }).then((res) => {
        this.selectAllText = "全选";
        this.selectArr.length = "0";
        this.selectAllBgColor = "#909399";
        this.imgArr = res.data.data;
        this.total = res.data.total;
        this.paginationInput = res.data.limit;
        this.changing = 1;
        this.sort = res.data.sort;
        var arr = JSON.parse(JSON.stringify(this.$store.getters.menuList)).splice(0, 2);
        arr[0].selectArr = [`${arr[0].id}_${newV}`];
        arr[1].selectArr = [`${arr[1].id}_${this.type}`];
        this.operationArr = arr;
        this.listNum = {
          download_num: res.data.download_num,
          order_time: res.data.order_time,
          order_total: res.data.order_total,
          total: res.data.total,
        };
      });
    },

    //修改选中日期的背景颜色
    value2(newVal) {
      this.isValue2Empty = !newVal;
    },

    value1(newVal) {
      this.isValue1Empty = !newVal;
    },
    value3(newVal) {
      this.isValue3Empty = !newVal;
    },
    value4(newVal) {
      this.isValue4Empty = !newVal;
    }
  },
  methods: {



    handleSave(dimensions) {
      this.sizeRange_1 = dimensions ; // 使用扩展运算符确保响应式
      this.selectImg();
    },
    handleClear() {
      this.sizeRange_1 = {}; // 清空 sizeRange_1
      this.selectImg();
    },
    type_one(selectedValues) {
      this.design = selectedValues;

      this.selectImg();
    },
    baoMi_e(val) {
      this.baoMi = val;
      this.selectImg();
    },
    pinFen_e(val) {
      this.pinFen = val;
      this.selectImg();
    },
    dengGuang_e(val) {
      this.dengGuang = val;
      this.selectImg();
    },
    banBen_e(val) {
      this.banBen = val;
      this.selectImg();
    },
    xiangJi_e(val) {
      this.xiangJi = val;
      this.selectImg();
    },
    senLin_e(val) {
      this.senLin = val;
      this.selectImg();
    },
    xuanRan_e(val) {
      this.xuanRan = val;
      this.selectImg();
    },


    setDefaultSelectedNode() {
      setTimeout(() => {
        if (this.$refs.tree) {
          this.$refs.tree.setCurrentKey('all'); // 设置默认选中为 'all'
        }
      }, 300)
    },
    handleCurrentChange_evt(currentNode) {
      // 当前选中节点变化时的处理逻辑
      this.selectedNode = currentNode;

      let params = {
        orField: this.orField,
        orWhere: this.orWhere,
        type: this.type,
        is_tag: this.checkInputIs_tag,
        not_tag: this.checkInputNot_tag,
        author: this.authorInput,
        time: this.value2,
        tag_type: this.radio[0],
        source_id: this.frontOrderInput,

        zhuShi: this.zhuShi,
        xiugai: this.value1,
        xiazai: this.value3,
        chakan: this.value4,
        design: this.design,
        baoMi: this.baoMi,
        pinFen: this.pinFen,
        shouJia: this.shouJia,
        xiaoShouE: this.xiaoShouE,
        dengGuang: this.dengGuang,
        xiangJi: this.xiangJi,
        senLin: this.senLin,
        banBen: this.banBen,


        compressSize: this.parseSizeRange(this.compressSize),
        sizeRange_1: this.sizeRange_1,
        MAX_daxiao: this.parseSizeRange(this.MAX_daxiao),
        Maps_da: this.parseSizeRange(this.Maps_da),
        Maps_shu: this.parseSizeRange(this.Maps_shu),
        object_shu: this.parseSizeRange(this.object_shu),
        shuCai_shu: this.parseSizeRange(this.shuCai_shu),
        dingDian_shu: this.parseSizeRange(this.dingDian_shu),
        xiazai_shu: this.parseSizeRange(this.xiazai_shu),
        chaKan_shu: this.parseSizeRange(this.chaKan_shu),
      };
      if (this.selectedNode.id !== "all") {
        params.id = this.selectedNode.id;

      }

      contentApi(params).then((res) => {
        if (res.code == 1000) {
          this.imgArr = res.data.data;
          this.total = res.data.total;
          this.paginationInput = res.data.limit;
          // this.changing = res.data.show;
          this.sort = res.data.sort;
          this.listNum = {
            download_num: res.data.download_num,
            order_time: res.data.order_time,
            order_total: res.data.order_total,
            total: res.data.total,
          };
        }
      });
    },
    transformToTree(data) {
      const map = {};
      const tree = [];

      // 第一步：构建节点映射表，并过滤掉 name 以 '0' 开头的节点
      data.forEach(item => {
        if (item.name.startsWith('0')) {
          return; // 如果 name 以 '0' 开头，则跳过该节点
        }
        const node = {
          id: item.id,
          name: item.name,
          num: item.num,
          parent_id: item.parent_id,
          sort: item.sort || 0, // 确保每个节点都有 sort 属性，默认值为 0
          children: []
        };
        map[item.id] = node;
      });

      // 第二步：构建树结构
      let totalNum = 0; // 用于记录所有节点的 num 总和（仅用于非“全部”节点）
      data.forEach(item => {
        if (item.name.startsWith('0')) {
          return; // 如果 name 以 '0' 开头，则跳过该节点
        }
        if (map[item.id]) { // 确保当前节点未被过滤掉
          const node = map[item.id];
          if (item.parent_id && map[item.parent_id]) {
            map[item.parent_id].children.push(node);
          } else {
            tree.push(node);
          }
          totalNum += item.num || 0; // 累加 num 值（仅用于非“全部”节点）
        }
      });

      // 第三步：创建“全部”节点并插入到树的最前面
      const allNode = {
        id: 'all',
        name: '全部',
        num: this.total || totalNum, // 使用 this.total 的值，如果没有则使用 totalNum
        parent_id: null,
        children: [] // “全部”节点没有子节点
      };

      // 第四步：递归排序树结构
      function sortTree(nodes) {
        if (!nodes || nodes.length === 0) return;
        nodes.sort((a, b) => a.sort - b.sort); // 根据 sort 属性排序
        nodes.forEach(node => sortTree(node.children)); // 对每个节点的子节点递归排序
      }

      sortTree(tree);

      return [allNode, ...tree]; // 返回包含“全部”节点的树结构
    },


    toggleDropdown() {
      this.isDropdownVisible = !this.isDropdownVisible; // 切换下拉菜单的显示状态
    },
    selectImage(image) {
      let _this = this ;
      _this.changing = image.num; // 更新 changing 状态

      sessionStorage.setItem('changing', image.num); // 将 changing 存入 sessionStorage
      _this.currentImageSrc = image.src; // 更新 currentImageSrc
      _this.isDropdownVisible = false; // 隐藏下拉菜单
      // 调用 changingEvt 方法
      _this.changingEvt(image.num);
    },
    hideDropdownIfClickedOutside(event) {
      // 检查点击是否发生在 dropdown-container 或其子元素之外
      const dropdownContainer = document.querySelector('.dropdown-container');
      if (dropdownContainer && !dropdownContainer.contains(event.target)) {
        this.isDropdownVisible = false;
      }
    },
    handleUpdate(key, value) {
      console.log(`Parent received update for ${key}:`, value);
      // 更新当前组件的状态
      this[key] = value;
      // 动态构造请求参数
      const params = {
        orField: this.orField,
        orWhere: this.orWhere,
        author: this.authorInput,
        time: this.value2,
        tag_type: this.radio[0],
        source_id: this.frontOrderInput,
        behindOrder: this.behindOrderInput,

        compressSize: this.parseSizeRange(this.compressSize),
        sizeRange_1: this.sizeRange_1,
        MAX_daxiao: this.parseSizeRange(this.MAX_daxiao),
        Maps_da: this.parseSizeRange(this.Maps_da),
        Maps_shu: this.parseSizeRange(this.Maps_shu),
        object_shu: this.parseSizeRange(this.object_shu),
        shuCai_shu: this.parseSizeRange(this.shuCai_shu),
        dingDian_shu: this.parseSizeRange(this.dingDian_shu),
        xiazai_shu: this.parseSizeRange(this.xiazai_shu),
        chaKan_shu: this.parseSizeRange(this.chaKan_shu),



        zhuShi: this.zhuShi,
        xiugai: this.value1,
        xiazai: this.value3,
        chakan: this.value4,
        design: this.design,
        baoMi: this.baoMi,
        pinFen: this.pinFen,
        shouJia: this.shouJia,
        xiaoShouE: this.xiaoShouE,
        dengGuang: this.dengGuang,
        xiangJi: this.xiangJi,
        senLin: this.senLin,
        banBen: this.banBen,

      };

      console.log('Parsed Maps_shu:', params.Maps_shu); // 打印解析后的值
      // 如果 selectedNode.id 存在，则添加 id 参数
      if (this.selectedNode && this.selectedNode.id) {
        params.id = this.selectedNode.id;
      }
      // 调用接口
      contentApi(params).then((res) => {
        if (res.code == 1000) {
          this.imgArr = res.data.data;
          this.total = res.data.total;
          this.paginationInput = res.data.limit;
          // this.changing = res.data.show;
          this.sort = res.data.sort;
          this.listNum = {
            download_num: res.data.download_num,
            order_time: res.data.order_time,
            order_total: res.data.order_total,
            total: res.data.total,
          };
        }
      });
    },

    // 解析大小范围的辅助函数
    parseSizeRange(sizeValue) {
      if (Array.isArray(sizeValue)) {
        return sizeValue;
      }
      if (typeof sizeValue === 'string') {
        // 清理输入中的多余空格
        sizeValue = sizeValue.trim();

        // 特别针对 "1111 - MB" 格式的输入
        const rangeWithUnitMatch = sizeValue.match(/^(\d+)\s*-\s*(\w+)$/);
        if (rangeWithUnitMatch) {
          const number = parseInt(rangeWithUnitMatch[1], 10);
          const unit = rangeWithUnitMatch[2];
          return [`${number}`, '', unit]; // 返回 [数值, 空字符串, 单位]
        }
        // 支持单边范围, 如 "111 -" 或 "- 15"
        const regexSingle = /^(\d+)\s*-\s*$|^-\s*(\d+)(?:\s+(\w+))?$/;
        let match = sizeValue.match(regexSingle);
        if (match) {
          const unit = match[3] || ''; // 不再默认为'KB'
          if (match[1]) { // 表示最小值
            const singleNumber = parseInt(match[1], 10);
            return [`${singleNumber}`, '', unit];
          } else if (match[2]) { // 表示最大值
            const singleNumber = parseInt(match[2], 10);
            return ['', `${singleNumber}`, unit];
          }
        }
        // 检查是否是简单的数字输入（例如 "111" 或 "111 KB"）
        const singleNumberMatch = sizeValue.match(/^(\d+)(?:\s+(\w+))?$/);
        if (singleNumberMatch) {
          const number = parseInt(singleNumberMatch[1], 10);
          const unit = singleNumberMatch[2] || ''; // 不再默认为'KB'
          return [`${number}`, '', unit];
        }

        // 原有的多条件匹配逻辑...
        const regex = /^(\d+)\s*([<>=])\s*(\d+)(?:\s+(\w+))?$/;
        match = sizeValue.match(regex);

        if (match) {
          const [_, num1, operator, num2, unit] = match;
          const parsedNum1 = parseInt(num1, 10);
          const parsedNum2 = parseInt(num2, 10);

          if (operator === '=') {
            if (parsedNum1 !== parsedNum2) {
              console.warn('Invalid input: Numbers on both sides of "=" must be equal.');
              return null;
            }
            return [`${parsedNum1}`, `${parsedNum1}`, unit || '']; // 如果没有单位，则为空字符串
          } else {
            const min = Math.min(parsedNum1, parsedNum2);
            const max = Math.max(parsedNum1, parsedNum2);
            return [`${min}`, `${max}`, unit || '']; // 如果没有单位，则为空字符串
          }
        }
      }

      const singleNumber = parseInt(sizeValue, 10);
      if (!isNaN(singleNumber)) {
        return [`${singleNumber}`, '', '']; // 不再默认为'KB', 第二个值为空字符串
      }
      return ['', '', '']; // 如果无法解析，返回两个空字符串和空的单位
    },


    // 关闭 Popover
    closePopover() {
      this.showPopover = false;
    },

    filterNode(value, data) {
      if (!value) return true; // 如果没有搜索值，返回 true 表示不过滤
      return data.name && data.name.indexOf(value) !== -1; // 根据 name 进行过滤
    },
    onFilter() {
      this.$refs.tree.filter(this.filterText);
      // 如果输入框内容为空，则重置树的状态
      if (!this.filterText) {
        this.resetTreeState();
      }
    },
    resetTreeState() {
      const allNodes = this.$refs.tree.store._getAllNodes();
      allNodes.forEach(node => {
        if (!node.isLeaf) {
          node.expanded = false; // 手动设置节点为折叠状态
        }
      });

      // 清除当前选中的节点（如果需要）
      this.$refs.tree.setCurrentKey(null);
    },

    //退出登录清除token
    outLoginEvt(e) {
      if (e == 1) {
        outLoginApi().then((res) => {
          if (res.code === 1000) {
            localStorage.removeItem("token");
            this.$router.push("/login");
          }
        });
      }
    },
    //按钮展开收回
    contractEvt(num) {
      this.contractNum = num;
      this.$store.dispatch("setContractNum", num);
    },
    handleSelect(e) {
      // this.$emit('fatherMethod');
      if (e == this.$route.path) {
        return;
      }
      this.$router.push(e);
    },
    //侧边栏
    topMenuEvt(e) {
      if (e == 1) {
        this.$router.push("/Back");
      } else if (e == 2) {
      } else if (e == 3) {
        this.$router.push("/PSpeople");
      } else if (e == 4) {
        this.$router.push("/user");
      } else if (e == 5) {
        this.$router.push("/income_box");
      } else if (e == 6) {
        this.$router.push("/Search_Records");
      } else if (e == 7) {
        this.$router.push("/Reference_statistics");
      } else if (e == 8) {
        this.$router.push("/ai");
      }
      else if (e == 9) {
        this.$router.push("/translate_fanyi");
      }
    },
    coverEvt() {
      this.$store.dispatch("setCoverShow", false);
    },

    clone_s() {
      this.dialogVisible = false
      this.dataTab = []
      this.dataOne = []
      this.tags = []
    },


    getStarImage(index) {
      return index <= this.selectedStars ? this.emptyStar : this.filledStar;
    },
    // 更新选中的星星数量
    selectStar(starCount) {
      this.selectedStars = starCount; // 直接设置选中的星星数量
      console.log(starCount, 1);

    },
    //将排序参数传递给子组件
    Min_BOX(props) {
      this.orField = props.orWhere,
        this.orWhere = props.order,
        this.selectImg()
    },
    //分页只显示前三页加总数
    showTotal(total) {
      return `共 ${total} 页`;
    },
    //键盘抬起事件
    handKeyEvt(e) {
      e = e || window.event;
      if (e.keyCode == 16) {
        this.shift = false;
        this.shiftFirst = false;
      }
    },
    //按下键盘事件
    handKeyCode(e) {
      e = e || window.event;
      if (this.focusDiyIpt == true) {
        return;
      }
      // 如果事件目标是输入框，则直接返回，不执行任何逻辑
      if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') {
        return;
      }
      if (this.imgArr.filter((res) => res.select == true).length !== 0) {
        //空格空格事件
        if (e.keyCode == 32) {
          this.dialogVisible = true;
          e.preventDefault();
        }
        // 键盘左键事件
        if (e.keyCode == 37) {
          if (this.spaceDialogNum == 1) {
            return;
          }
          e.preventDefault();
          this.spaceDialogNum -= 2;
          this.spaceDialogEvt();
        }
        //键盘右键事件
        if (e.keyCode == 39) {
          if (this.spaceDialogNum == this.selectArr.length) {
            return;
          }
          e.preventDefault();
          this.spaceDialogEvt();
        }
        // 键盘1事件（标签操作后）
        if (e.keyCode == 49 || e.keyCode == 97) {
          this.fingerboard1Evt();
        }
        //键盘2事件（标签操作后）
        if (e.keyCode == 50 || e.keyCode == 98) {
          this.fingerboard2Evt();
        }
        //键盘Delete事件
        if (e.keyCode == 8 || e.keyCode == 46) {
          if (
            this.dialogVisible == true ||
            this.searchLabelDialog == true ||
            this.rightLabelDialog == true ||
            this.deleteVisible == true ||
            this.uploadVisible == true
          ) {
            e.preventDefault();
            return;
          }
          this.deleteVisible = true;
        }
      }
      //键盘I事件
      if (e.keyCode == 73) {
        if (this.changing >= 3) {
          this.changing = 1;
        } else {
          this.changing++;
        }
        this.changingEvt(this.changing);
      }
      //shift 事件
      if (e.keyCode == 16) {
        this.shift = true;
        this.shiftFirst = true;
      }
      //键盘0清除选择
      if (e.keyCode == 48 || e.keyCode == 96 || e.keyCode == 67) {
        if (
          this.dialogVisible == true ||
          this.searchLabelDialog == true ||
          this.rightLabelDialog == true ||
          this.deleteVisible == true ||
          this.uploadVisible == true
        ) {
          return;
        }
        this.imgArr = this.imgArr.map((res) => {
          res.select = false;
          return res;
        });
        this.selectArr = this.imgArr.filter((res) => res.select == true);
      }
      //键盘A事件（全选）
      if (e.keyCode == 65) {
        this.imgArr = this.imgArr.map((res) => {
          res.select = true;
          return res;
        });
        this.selectArr = this.imgArr.filter((res) => res.select == true);
        this.selectAllText = "取消全选";
        this.selectAllBgColor = "#909399";
      }
      //键盘v事件
      if (e.keyCode == 86) {
        if (this.dialogVisible == true) {
          this.changingImg = !this.changingImg;
          // this.$nextTick(() => {
          //     new flexImages({
          //         selector: ".spaceDialogImg1",
          //     });
          // });
        }
      }


      //Page Up 翻页
      if (e.keyCode == 34) {
        if (
          this.dialogVisible == true ||
          this.searchLabelDialog == true ||
          this.rightLabelDialog == true ||
          this.deleteVisible == true ||
          this.uploadVisible == true
        ) {
          e.preventDefault();
          return;
        }
        this.loading = true
        e.preventDefault();
        delay(() => {
          this.currentPage1++;
          contentApi({
            is_tag: this.checkInputIs_tag,
            not_tag: this.checkInputNot_tag,
            author: this.authorInput,
            time: this.value2,
            sort: this.sort,
            tag_type: this.radio[0],
            tag_id: this.labelId,
            source_id: this.frontOrderInput,
            behindOrder: this.behindOrderInput,
            limit: this.paginationInput,
            page: this.currentPage1,
            type: this.type,
            process: this.$store.getters.process,
          }).then((res) => {
            if (res.code == 1000) {
              this.imgArr = res.data.data;
              this.total = res.data.total;
              this.paginationInput = res.data.limit;
              // this.changing = res.data.show;
              this.sort = res.data.sort;
              this.pagefenye = true;  //点击分页 滚动条为0
              let as = document.querySelector('.flex-images  , .el-table__body-wrapper')
              this.imgScrollEvt(as)
              this.loading = false
              this.listNum = {
                download_num: res.data.download_num,
                order_time: res.data.order_time,
                order_total: res.data.order_total,
                total: res.data.total,
              };
            }
          });
        }, 300);
      }
      // Page Down向后分页
      if (e.keyCode == 33) {
        if (
          this.dialogVisible == true ||
          this.searchLabelDialog == true ||
          this.rightLabelDialog == true ||
          this.deleteVisible == true ||
          this.uploadVisible == true
        ) {
          e.preventDefault();
          return;
        }
        this.loading = true
        delay(() => {
          if (this.currentPage1 <= 1) {
            this.currentPage1 = 1;
          } else {
            this.currentPage1--;
          }
          contentApi({
            is_tag: this.checkInputIs_tag,
            not_tag: this.checkInputNot_tag,
            author: this.authorInput,
            time: this.value2,
            sort: this.sort,
            tag_type: this.radio[0],
            tag_id: this.labelId,
            source_id: this.frontOrderInput,
            behindOrder: this.behindOrderInput,
            limit: this.paginationInput,
            page: this.currentPage1,
            type: this.type,
            process: this.$store.getters.process,
          }).then((res) => {
            if (res.code == 1000) {
              this.imgArr = res.data.data;
              this.total = res.data.total;
              this.paginationInput = res.data.limit;
              // this.changing = res.data.show;
              this.sort = res.data.sort;

              this.pagefenye = true;  //点击分页 滚动条为0
              let as = document.querySelector('.flex-images  , .el-table__body-wrapper')
              this.imgScrollEvt(as)


              this.loading = false
              this.listNum = {
                download_num: res.data.download_num,
                order_time: res.data.order_time,
                order_total: res.data.order_total,
                total: res.data.total,
              };
            }
          });
        }, 300);
      }
      //键盘5事件  剩余全否
      if (e.keyCode == 53 || e.keyCode == 101) {
        this.allNoEvt();
      }

    },
    //滑动事件
    imgScrollEvt(e) {
      var e =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        e ||
        document.body.scrollTop;
      //点击分页 滚动条为0
      if (this.pagefenye == true) {
        e.scrollTop = 0;
        this.pagefenye = false
        return
      }
      if (e.target._prevClass !== "el-main el-mian") {
        false;
      }
      var scrollTop = e.target.scrollTop;
      let scrollStep = scrollTop - this.oldScrollTop;
      this.oldScrollTop = scrollTop;
      if (scrollTop <= 0) {
        this.header = true;
        this.$store.dispatch("setShowHeader", this.header);
        return;
      }
      if (scrollStep == 0) {
        this.header = true;
        this.$store.dispatch("setShowHeader", this.header);
        return;
      }
      if (scrollStep < 0) {
        this.header = true;
        this.$store.dispatch("setShowHeader", this.header);
      } else {
        this.header = true;
        this.$store.dispatch("setShowHeader", this.header);
      }
    },
    //弹窗属于事件
    belongEvt() {
      this.fingerboard1Evt();
    },
    //弹窗不s属于事件
    noBelongEvt() {
      this.fingerboard2Evt();
    },
    //键盘1事件
    fingerboard1Evt() {
      const formData = new FormData();
      if (this.dialogVisible == true && this.operateNum.show == true) {
        this.belongShow = 0;

        this.spaceObjData[this.spaceDialogId[0]].label = this.spaceObjData[
          this.spaceDialogId[0]
        ].label.map((res) => {
          for (let key in res.children) {
            if (res.children[key].id == this.labelId) {
              res.children[key].status = 0;
            }
          }
          return res;
        });

        return;
      }
      if (this.operateNum.show == true) {
        this.getSourceId().map((res) => {
          formData.append("source_ids[]", res);
        });
        formData.append("is_tag", this.labelId);
        fingerboardNumApi(formData).then((res) => {
          if (res.code == 1000) {
            // this.loading = true
            var id = this.imgArr.map((res) => {
              return res.source_id;
            });
            singleLabelApi({
              tag_id: this.labelId,
              type: this.type,
              process: this.$store.getters.process,
              source_ids: id,
            }).then((val) => {
              if (val.code == 1000) {
                this.operateNum = val.data;
                this.operateNum.show = true;
                let arr = [];
                this.imgArr.map((v) => {
                  val.data.refers.map((l) => {
                    if (v.source_id == l.source_id) {
                      v.status = l.status;
                      arr.push(v);
                    }
                  });
                });
                this.imgArr = arr;
                // this.loading = false
              }
            });
            this.belongShow = true;
          }
        });
      }
    },
    //键盘2事件
    fingerboard2Evt() {
      if (this.labelAjax == true) {
        return;
      }
      const formData = new FormData();
      if (this.operateNum.show == true && this.dialogVisible == true) {
        this.belongShow = 1;
        this.spaceObjData[this.spaceDialogId[0]].label = this.spaceObjData[
          this.spaceDialogId[0]
        ].label.map((res) => {
          for (let key in res.children) {
            if (res.children[key].id == this.labelId) {
              res.children[key].status = 1;
            }
          }
          return res;
        });
        return;
      }
      if (this.operateNum.show == true) {
        this.getSourceId().map((res) => {
          formData.append("source_ids[]", res);
        });
        formData.append("not_tag", this.labelId);
        fingerboardNumApi(formData).then((res) => {
          if (res.code == 1000) {
            // this.loading = true
            var id = this.imgArr.map((res) => {
              return res.source_id;
            });
            singleLabelApi({
              tag_id: this.labelId,
              type: this.type,
              process: this.$store.getters.process,
              source_ids: id,
            }).then((val) => {
              if (val.code == 1000) {
                this.operateNum = val.data;
                this.operateNum.show = true;
                let arr = [];
                this.imgArr.map((v) => {
                  val.data.refers.map((l) => {
                    if (v.source_id == l.source_id) {
                      v.status = l.status;
                      arr.push(v);
                    }
                  });
                });
                this.imgArr = arr;
                // this.loading = false
              }
            });
            this.belongShow = false;
          }
        });
      }
    },
    //图片点击事件
    imgEvt(e, index) {
      if (this.selectArr.length >= 1 && this.shift === true) {
        let start,
          end = "";
        for (var i = 0; this.imgArr.length > i; i++) {
          if (this.imgArr[i].source_id === e.source_id) {
            start = i;
          }
          if (
            this.imgArr[i].source_id !== e.source_id &&
            this.imgArr[i].select === true
          ) {
            end = i;
          }
        }
        if (start || (start == 0 && end)) {
          if (start > end) {
            let temp = "";
            temp = end;
            end = start;
            start = temp;
          } else {
            start++;
          }
          for (var i = 0; this.imgArr.length > i; i++) {
            if (i >= start && i < end) {
              this.imgArr[i].select = true;
            }
          }
        }
      }
      this.imgArr = this.imgArr.map((res) => {
        if (res.source_id == e.source_id) {
          if (res.select) {
            res.select = "";
          } else {
            res.select = true;
          }
        }
        return res;
      });
      this.selectArr = this.imgArr.filter((res) => res.select == true);
      this.activeIndex_copy = index

    },
    //排序
    sortEvt(res) {
      this.sort = res;
      switch (res) {
        case "8":
          this.sortName = "点击查看次数最多";
          this.review = 8;
          break;
        case "9":
          this.sortName = "收藏最多";
          this.favorite = 9;
          break;
        case "1":
          this.sortName = "上传时间-升序";
          this.review = null;
          this.favorite = null;
          break;
        case "2":
          this.sortName = "上传时间-降序";
          this.review = null;
          this.favorite = null;
          break;
        case "3":
          this.sortName = "文件大小-升序";
          this.review = null;
          this.favorite = null;
          break;
        case "4":
          this.sortName = "文件大小-降序";
          this.review = null;
          this.favorite = null;
          break;
        case "5":
          this.sortName = "文件尺寸-升序";
          this.review = null;
          this.favorite = null;
          break;
        case "6":
          this.sortName = "文件尺寸-降序";
          this.review = null;
          this.favorite = null;
          break;
        case "7":
          this.sortName = "下载次数最多";
          this.review = null;
          this.favorite = null;
          break;
      }
      contentApi({
        orField: this.orField,
        orWhere: this.orWhere,

        sort: res,
        tag_type: this.radio[0],
        tag_id: this.labelId,
        is_tag: this.checkInputIs_tag,
        not_tag: this.checkInputNot_tag,
        author: this.authorInput,
        time: this.value2,
        source_id: this.frontOrderInput,
        behindOrder: this.behindOrderInput,
        limit: this.paginationInput,
        type: this.type,
        process: this.$store.getters.process,
      }).then((res) => {
        if (res.code == 1000) {
          this.imgArr = res.data.data;
          this.total = res.data.total;
          this.paginationInput = res.data.limit;
          // this.changing = res.data.show;
          this.sort = res.data.sort;
          this.listNum = {
            download_num: res.data.download_num,
            order_time: res.data.order_time,
            order_total: res.data.order_total,
            total: res.data.total,
          };
        }
      });
      this.setSessStorage();
    },
    //分页
    handleCurrentChange(e) {
      this.loading = true
      contentApi({
        behindOrder: this.behindOrderInput,
        limit: this.paginationInput,
        page: e,
        tag_type: this.radio[0],
        tag_id: this.labelId,
        sort: this.sort,
        behindOrder: this.behindOrderInput,
        process: this.$store.getters.process,
        orField: this.orField,
        orWhere: this.orWhere,
        type: this.type,
        is_tag: this.checkInputIs_tag,
        not_tag: this.checkInputNot_tag,
        tag_type: this.radio[0],


        source_id: this.frontOrderInput,
        author: this.authorInput,
        zhuShi: this.zhuShi,

        time: this.value2,
        xiugai: this.value1,
        xiazai: this.value3,
        chakan: this.value4,

        baoMi: this.baoMi,
        pinFen: this.pinFen,

        shouJia: this.shouJia,
        xiaoShouE: this.xiaoShouE,
        dengGuang: this.dengGuang,
        xiangJi: this.xiangJi,
        senLin: this.senLin,
        banBen: this.banBen,

        sizeRange_1: this.sizeRange_1,
        compressSize: this.parseSizeRange(this.compressSize),
        MAX_daxiao: this.parseSizeRange(this.MAX_daxiao),
        Maps_da: this.parseSizeRange(this.Maps_da),
        Maps_shu: this.parseSizeRange(this.Maps_shu),
        object_shu: this.parseSizeRange(this.object_shu),
        shuCai_shu: this.parseSizeRange(this.shuCai_shu),
        dingDian_shu: this.parseSizeRange(this.dingDian_shu),
        xiazai_shu: this.parseSizeRange(this.xiazai_shu),
        chaKan_shu: this.parseSizeRange(this.chaKan_shu),


        design: this.design,



      }).then((res) => {
        if (res.code == 1000) {
          
          this.imgArr = res.data.data;
          this.total = res.data.total;
          this.paginationInput = res.data.limit;
          // this.changing = res.data.show;
          this.sort = res.data.sort;
          this.pagefenye = true;  //点击分页 滚动条为0
          let as = document.querySelector('.flex-images  ,   .el-table__body-wrapper')
          this.imgScrollEvt(as)
          this.loading = false
          this.listNum = {
            download_num: res.data.download_num,
            order_time: res.data.order_time,
            order_total: res.data.order_total,
            total: res.data.total,
          };
        }
      });
    },
    //分页输入框
    limitEvt(e) {
      contentApi({
        tag_type: this.radio[0],
        tag_id: this.labelId,
        sort: this.sort,
        behindOrder: this.behindOrderInput,
        limit: e,
        process: this.$store.getters.process,


        orField: this.orField,
        orWhere: this.orWhere,
        type: this.type,
        is_tag: this.checkInputIs_tag,
        not_tag: this.checkInputNot_tag,
        author: this.authorInput,
        time: this.value2,
        tag_type: this.radio[0],
        source_id: this.frontOrderInput,


        zhuShi: this.zhuShi,
        xiugai: this.value1,
        xiazai: this.value3,
        chakan: this.value4,
        design: this.design,
        baoMi: this.baoMi,
        pinFen: this.pinFen,
        shouJia: this.shouJia,
        xiaoShouE: this.xiaoShouE,
        dengGuang: this.dengGuang,
        xiangJi: this.xiangJi,
        senLin: this.senLin,
        banBen: this.banBen,

        compressSize: this.parseSizeRange(this.compressSize),
        sizeRange_1: this.sizeRange_1,
        MAX_daxiao: this.parseSizeRange(this.MAX_daxiao),
        Maps_da: this.parseSizeRange(this.Maps_da),
        Maps_shu: this.parseSizeRange(this.Maps_shu),
        object_shu: this.parseSizeRange(this.object_shu),
        shuCai_shu: this.parseSizeRange(this.shuCai_shu),
        dingDian_shu: this.parseSizeRange(this.dingDian_shu),
        xiazai_shu: this.parseSizeRange(this.xiazai_shu),
        chaKan_shu: this.parseSizeRange(this.chaKan_shu),
      }).then((res) => {
        if (res.code == 1000) {
          this.imgArr = res.data.data;
          this.total = res.data.total;
          this.paginationInput = res.data.limit;
          // this.changing = res.data.show;
          this.sort = res.data.sort;
          this.listNum = {
            download_num: res.data.download_num,
            order_time: res.data.order_time,
            order_total: res.data.order_total,
            total: res.data.total,
          };
        }
      });
    },
    //标签查询获取焦点
    searchLabelEvt() {
      this.searchLabelDialog = true;
    },
    searchLabel1Evt() {
      this.searchFor = true;
    },
    //
    mousemoveEvt(res) {
      this.mousemoveId = res.source_id;
    },
    mouseoutEvt() {
      this.mousemoveId = "";
    },
    //空格弹窗打开
    spaceDialogEvt() {
      if (this.spaceDialogNum < 0) {
        this.spaceDialogNum = 0;
      }
      let arrID = this.selectArr.map((res) => {
        return res.source_id;
      });
      let determine = false;
      this.spaceDialogId = [];
      this.spaceDialogId.push(arrID[this.spaceDialogNum]);

      this.spaceSrc = this.selectArr[this.spaceDialogNum].big_img;
      this.spaceDialogNum++;
      if (JSON.stringify(this.spaceObjData) !== "{}") {
        for (let key in this.spaceObjData) {
          if (key == this.spaceDialogId[0]) {
            this.spaceImgInfo = this.spaceObjData[key].info;
            this.spaceWidth = this.spaceObjData[key].w;
            this.spaceHeight = this.spaceObjData[key].h;
            this.spaceLabelArr = this.spaceObjData[key].label;
            this.spaceLabelArr.map((a) => {
              for (const key in a.children) {
                if (a.children[key].title == this.operateLabelInput) {
                  if (a.children[key].status == 0) {
                    this.belongShow = 0;
                  } else if (a.children[key].status == 1) {
                    this.belongShow = 1;
                  } else if (a.children[key].status == 3) {
                    this.belongShow = 3;
                  }
                }
              }
            });
            if (!this.spaceObjData[this.spaceDialogId[0]].front) {
              this.frontSpaceWidth = "auto";
              this.frontSpaceHeight = "850px";
            } else {
              this.frontSpaceWidth = "550px";
              this.frontSpaceHeight = "auto";
            }
            determine = true;
          }
        }
      }
      if (determine == true) {
        determine = false;
        return;
      }
      const formData = new FormData();
      formData.append("source_ids[]", this.spaceDialogId);
      formData.append("process", this.process);
      getModelImgLabelApi(formData).then((res) => {
        if (res.code == 1000) {
          let imginfo = {
            id: this.spaceDialogId[0],
            author: res.data.author,
            create_time: res.data.create_time,
            w: res.data.width,
            h: res.data.height,
          };
          this.spaceLabelArr = res.data.tag;
          this.spaceImgInfo = imginfo;

          this.spaceLabelArr = this.spaceLabelArr.map((a) => {
            for (const key in a.children) {
              if (a.children[key].title == this.operateLabelInput) {
                if (a.children[key].status == 0) {
                  this.belongShow = 0;
                } else if (a.children[key].status == 1) {
                  this.belongShow = 1;
                } else if (a.children[key].status == 3) {
                  this.belongShow = 3;
                }
              }
            }
            return a;
          });
          this.spaceObjData[this.spaceDialogId[0]] = {};
          this.spaceObjData[this.spaceDialogId[0]].label = this.spaceLabelArr;
          this.spaceObjData[this.spaceDialogId[0]].info = {
            ...imginfo,
          };
          let num = this.spaceImgInfo.w / this.spaceImgInfo.h;
          if (res.data.height - 0 > res.data.width - 0) {
            this.spaceObjData[this.spaceDialogId[0]].front = true;
            this.frontSpaceWidth = "auto";
            // this.frontSpaceHeight = "850px";
            this.frontSpaceHeight = "100%";
          } else {
            this.spaceObjData[this.spaceDialogId[0]].front = false;
            // this.frontSpaceWidth = "550px";
            this.frontSpaceWidth = "100%";
            this.frontSpaceHeight = "auto";
          }
          if (parseInt(num) == 3) {
            this.spaceObjData[this.spaceDialogId[0]].w = "auto";
            this.spaceWidth = "auto";
            this.spaceHeight = "500px";
            this.spaceObjData[this.spaceDialogId[0]].h = "500px";
          } else if (parseInt(num) == 4) {
            this.spaceObjData[this.spaceDialogId[0]].w = "auto";
            this.spaceWidth = "auto";
            this.spaceHeight = "400px";
            this.spaceObjData[this.spaceDialogId[0]].h = "400px";
          } else if (parseInt(num) == 5) {
            this.spaceObjData[this.spaceDialogId[0]].w = "auto";
            this.spaceWidth = "auto";
            this.spaceHeight = "317px";
            this.spaceObjData[this.spaceDialogId[0]].h = "300px";
          } else {
            this.spaceWidth = "auto";
            // this.spaceHeight = "850px";
            this.spaceHeight = "100%";
            this.spaceObjData[this.spaceDialogId[0]].w = "auto";
            // this.spaceObjData[this.spaceDialogId[0]].h = "850px";
            this.spaceObjData[this.spaceDialogId[0]].h = "100%";
          }
        }
      });
    },
    //空格弹窗全部否
    allNoEvt() {
      this.spaceLabelArr = this.spaceLabelArr.map((res) => {
        for (const key in res.children) {
          if (res.children[key].status == 3) {
            res.children[key].status = 1;
          }
        }
        return res;
      });
    },
    //图片切换
    arrowLeftEvt() {
      if (this.spaceDialogNum == 1) {
        return;
      }
      this.spaceDialogNum -= 2;
      this.spaceDialogEvt();
    },
    //图片切换
    arrowRightEvt() {
      if (this.spaceDialogNum == this.selectArr.length) {
        return;
      }
      this.spaceDialogEvt();
    },

    //空格弹窗切换
    changingImgEvt() {
      this.changingImg = !this.changingImg;
    },
    // 获取已选中图片的source_id
    getSourceId() {
      var source_ids = this.selectArr.map((res) => res.source_id);
      return source_ids;
    },
    //搜索弹窗打开
    searchDialogEvt() {
      if (this.labelArr.length !== 0) {
        return;
      }
      this.labelArr = [];

      getModelLabelApi({
        type: this.type,
        process: this.$store.getters.process,
      }).then((res) => (this.labelArr = res.data.tag));
    },
    //右键搜索弹窗打开
    rightDialogEvt() {
      const formData = new FormData();
      this.getSourceId().map((res) => {
        formData.append("source_ids[]", res);
      });
      getModelImgLabelApi(formData).then((res) => {
        if (res.code == 1000) {
          this.labelArr = res.data.tag;
        }
      });
    },
    //标签改变状态
    colorEvt(e) {
      this.labelArr = this.labelArr.map((val) => {
        if (val.one == true && e.parent_id == val.id) {
          for (let key in val.children) {
            if (e.id == val.children[key].id) {
              if (val.children[key].status == 1) {
                val.children[key].status = 3;
              } else if (val.children[key].status == 0) {
                val.children[key].status = 1;
              } else if (val.children[key].status == 3) {
                val.children[key].status = 0;
              }
            }
          }
        }
        return val;
      });
    },
    color1Evt(e) {
      this.spaceLabelArr = this.spaceLabelArr.map((val) => {
        if (val.one == true && e.parent_id == val.id) {
          for (let key in val.children) {
            if (e.id == val.children[key].id) {
              if (val.children[key].status == 1) {
                val.children[key].status = 3;
              } else if (val.children[key].status == 0) {
                val.children[key].status = 1;
              } else if (val.children[key].status == 3) {
                val.children[key].status = 0;
              }
            }
          }
        }
        return val;
      });
    },
    //标签事件（搜索弹窗）
    searchLabEvt(e) {
      this.labelArr = this.labelArr.map((val) => {
        if (val.one == true && e.parent_id == val.id) {
          for (let key in val.children) {
            val.children[key].status = 1;
            if (e.id == val.children[key].id) {
              val.children[key].status = 0;
            }
          }
          return val;
        }
        for (let key in val.children) {
          if (e.id == val.children[key].id) {
            if (val.children[key] !== null) {
              if (val.children[key].status == 3 || val.children[key].status == 2) {
                val.children[key].status = 0;
              } else if (val.children[key].status == 0) {
                val.children[key].status = 1;
              } else if (val.children[key].status == 1) {
                val.children[key].status = 3;
              }
            }
          }
        }
        return val;
      });
    },
    //点击标签（标签操作）
    labelSearchEvt(e) {
      let id = this.imgArr.map((res) => {
        return res.source_id;
      });
      this.labelArr = this.labelArr.map((val) => {
        if (val.one == true && e.parent_id == val.id) {
          this.labelAjax = true;
        } else {
          this.labelAjax = false;
        }
        for (let key in val.children) {
          val.children[key].status = 3;
          if (e.id == val.children[key].id) {
            val.children[key].status = 1;
            singleLabelApi({
              is_tag: this.checkInputIs_tag,
              not_tag: this.checkInputNot_tag,
              author: this.authorInput,
              time: this.value2,
              source_id: this.frontOrderInput,
              tag_id: val.children[key].id,
              type: this.type,
              process: this.$store.getters.process,
              source_ids: id,
            }).then((res) => {
              if (res.code == 1000) {
                this.operateNum = res.data;
                this.operateNum.show = true;
                let arr = [];
                this.imgArr.map((v) => {
                  res.data.refers.map((l) => {
                    if (v.source_id == l.source_id) {
                      v.status = l.status;
                      arr.push(v);
                    }
                  });
                });
                this.imgArr = arr;
              }
            });
            setTimeout(() => {
              this.searchLabelDialog = false;
              this.operateLabelInput = e.title;
              this.labelId = e.id;
              this.radio = ["1"];
              this.setSessStorage();
            }, 500);
          }
        }
        return val;
      });
    },
    //确认关闭右键弹窗
    submitRightLabelEvt() {
      //绿色标签
      let is_tag = [];
      //红色标签
      let not_tag = [];
      let other_tag = [];
      let hui_tag = [];

      this.labelArr.map((res) => {
        for (let key in res.children) {
          if (res.children[key].status == 0) {
            is_tag.push(res.children[key].id);
          }
          if (res.children[key].status == 1) {
            not_tag.push(res.children[key].id);
          }
          if (res.children[key].status == 2) {
            other_tag.push(res.children[key].id);
          }
          if (res.children[key].status == 3) {
            hui_tag.push(res.children[key].id);
          }
        }
      });
      rightStickLabelApi({
        source_ids: this.getSourceId(),
        is_tag,
        not_tag,
        other_tag,
      }).then((res) => {
        if (res.code == 1000) {
          if (this.operateNum.show) {
            let id = this.getSourceId();
            let arr = is_tag.filter((res) => res == this.labelId);
            let arr1 = not_tag.filter((res) => res == this.labelId);
            let arr2 = hui_tag.filter((res) => res == this.labelId);

            if (arr.length !== 0) {
              this.imgArr = this.imgArr.map((res) => {
                id.map((val) => {
                  if (res.source_id == val) {
                    res.status = 0;
                  }
                });
                return res;
              });
            }
            if (arr1.length !== 0) {
              this.imgArr = this.imgArr.map((res) => {
                id.map((val) => {
                  if (res.source_id == val) {
                    res.status = 1;
                  }
                });
                return res;
              });
            }
            if (arr2.length !== 0) {
              this.imgArr = this.imgArr.map((res) => {
                id.map((val) => {
                  if (res.source_id == val) {
                    res.status = 3;
                  }
                });
                return res;
              });
            }
          }
          this.rightLabelDialog = false;
        }
      });
    },
    //确认关闭空格弹窗
    submitSpaceLabelEvt() {
      let data = {};
      for (let key in this.spaceObjData) {
        data[key] = {};
        data[key].is_tag = [];
        data[key].not_tag = [];
        data[key].hui_tag = [];

        this.spaceObjData[key].label.map((res) => {
          for (let v in res.children) {
            if (res.children[v].status == 0) {
              data[key].is_tag.push(res.children[v].id);
            }
            if (res.children[v].status == 1) {
              data[key].not_tag.push(res.children[v].id);
            }
            if (res.children[v].status == 3) {
              data[key].hui_tag.push(res.children[v].id);
            }
          }
        });
      }

      stickLabelApi({
        data,
      }).then((res) => {
        if (res.code == 1000) {
          if (this.operateNum.show) {
            this.imgArr = this.imgArr.map((i) => {
              for (let v in data) {
                if (i.source_id == v) {
                  let arr = data[v].is_tag.filter((res) => res == this.labelId);
                  let arr1 = data[v].not_tag.filter((res) => res == this.labelId);
                  let arr2 = data[v].hui_tag.filter((res) => res == this.labelId);

                  if (arr.length !== 0) {
                    i.status = 0;
                  }
                  if (arr1.length !== 0) {
                    i.status = 1;
                  }
                  if (arr2.length !== 0) {
                    i.status = 3;
                  }
                }
              }
              return i;
            });
          }
          this.spaceObjData = {};
          this.$message({
            message: "更改成功",
            type: "success",
          });
          this.dialogVisible = false;
        }
      });
    },

    //空格空格弹窗关闭
    handleClose(done) {
      this.dialogVisible = false;
      this.deleteVisible = false;
      this.spaceDialogNum = 0;
    },
    //关闭弹窗
    closeEvt() {
      this.labelArr = [];
    },
    //关闭空格弹窗
    cancellationEvt() {
      this.dialogVisible = false;
    },
    spaceCloseDiaEvt() {
      this.spaceObjData = {};
      this.spaceDialogNum = 0;
    },
    //切换标签
    labelEvt(res) {
      this.spaceLabelArr = this.spaceLabelArr.map((val) => {
        if (val.one == true && res.parent_id == val.id) {
          for (let key in val.children) {
            val.children[key].status = 1;
            if (res.id == val.children[key].id) {
              val.children[key].status = 0;
            }
          }
          return val;
        }
        for (let key in val.children) {
          if (res.id == val.children[key].id) {
            if (val.children[key] !== null) {
              if (val.children[key].status == 3 || val.children[key].status == 2) {
                val.children[key].status = 0;
              } else if (val.children[key].status == 0) {
                val.children[key].status = 1;
              } else if (val.children[key].status == 1) {
                val.children[key].status = 3;
              }
            }
          }
        }
        return val;
      });
      for (let key in this.spaceObjData) {
        if (key == this.spaceDialogId[0]) {
          this.spaceObjData[key].label = this.spaceLabelArr;
        }
      }
    },
    //切换排序方式
    changingEvt(num) {
      // show
      showApi({
        show: num,
      }).then((res) => {
        if (res.code == 1000) {
          this.changing = num;
        }
      });
    },
    //标签操作事件（头部）
    checkboxEvt(e) {
      this.loading = true;
      if (e.length == 0) {
        delay(() => {
          this.radio = this.radioNum;
          this.setSessStorage();
          this.selectImg();
        }, 300);
        return;
      }
      this.radio = [];
      if (e.length == 1) {
        this.radio.push(e[0]);
      } else {
        this.radio.push(e[1]);
      }
      delay(() => {
        this.radioNum = this.radio;
        this.setSessStorage();
        this.selectImg();
      }, 300);
    },
    //改变图片选项
    checkbox1Evt(e) {
      e.selectArr = e.selectArr.slice(-1);
    },
    //图片鼠标右键事件
    rightClickEvt() {
      if (this.selectArr.length != 0) {
        this.labelArr = [];
        this.rightLabelDialog = true;
      }
    },
    //出现改变弹窗
    leftSelectEvt(e) {
      this.showChangeImg(e, true);
    },
    //关改变弹窗闭
    cancelEvt(e) {
      this.showChangeImg(e, false);
    },
    //弹窗组件方法
    cancel(params) {
      this.searchFor = params;
    },
    revise(params) {
      this.imgArr = params.data;
      this.total = params.total;
      this.paginationInput = params.limit;
    },
    reviseText(params) {
      let str = "";
      this.checkInputIs_tag = params.filter((res) => res.status == 0);
      this.checkInputNot_tag = params.filter((res) => res.status == 1);
      this.checkInputIs_tag = this.checkInputIs_tag.map((res) => {
        return res.id;
      });
      this.checkInputNot_tag = this.checkInputNot_tag.map((res) => {
        return res.id;
      });
      params.map((res) => {
        str += `${res.title},`;
      });
      this.checkInput = str;
      this.setSessStorage();
    },
    //改变弹出方法
    showChangeImg(e, boolean) {
      this.imgArr = this.imgArr.map((res) => {
        if (res.source_id == e.source_id) {
          res.leftSelect = boolean;
        }
        return res;
      });
      this.$store.dispatch("setCoverShow", boolean);
    },
    //上传
    uploadEvt() {
      this.uploadVisible = true;
      // window.open('/upload')
      // this.$router.push('/upload')
    },
    //确认改变图片
    changeImgEvt(e) {
      var str = this.operationArr[0].selectArr[0].slice(-1);
      var str1 = this.operationArr[1].selectArr[0].slice(-1);
      var arr = this.selectArr.map((val) => {
        return val.source_id;
      });
      changeModeImgApi({
        process: str,
        type: str1,
        source_ids: arr,
      }).then((res) => {
        if (res.code == 1000) {
          this.imgArr = this.imgArr.map((a) => {
            this.selectArr.map((val) => {
              if (a.source_id == val.source_id) {
                a = {};
              }
            });
            return a;
          });
          var arr = JSON.parse(JSON.stringify(this.$store.getters.menuList)).splice(0, 2);
          arr[0].selectArr = [`${arr[0].id}_${this.$store.getters.process}`];
          arr[1].selectArr = [`${arr[1].id}_${this.type}`];
          this.operationArr = arr;
          this.showChangeImg(e, false);
        }
      });
    },


    clearEvt1() {
      this.checkInputIs_tag = [];
      this.checkInputNot_tag = [];
      this.selectImg();
    },
    clearEvt2() {
      this.selectImg();
    },

    //查询
    selectImg() {
      contentApi({
        orField: this.orField,
        orWhere: this.orWhere,
        type: this.type,
        is_tag: this.checkInputIs_tag,
        not_tag: this.checkInputNot_tag,
        tag_type: this.radio[0],

        time: this.value2,
        author: this.authorInput,
        source_id: this.frontOrderInput,
        zhuShi: this.zhuShi,
        xiugai: this.value1,
        xiazai: this.value3,
        chakan: this.value4,
        design: this.design,
        baoMi: this.baoMi,
        pinFen: this.pinFen,
        shouJia: this.shouJia,
        xiaoShouE: this.xiaoShouE,
        dengGuang: this.dengGuang,
        xiangJi: this.xiangJi,
        senLin: this.senLin,
        banBen: this.banBen,
        xuanRan: this.xuanRan,
        process: this.$store.getters.process,
        compressSize: this.parseSizeRange(this.compressSize),
        sizeRange_1: this.sizeRange_1,
        MAX_daxiao: this.parseSizeRange(this.MAX_daxiao),
        Maps_da: this.parseSizeRange(this.Maps_da),
        Maps_shu: this.parseSizeRange(this.Maps_shu),
        object_shu: this.parseSizeRange(this.object_shu),
        shuCai_shu: this.parseSizeRange(this.shuCai_shu),
        dingDian_shu: this.parseSizeRange(this.dingDian_shu),
        xiazai_shu: this.parseSizeRange(this.xiazai_shu),
        chaKan_shu: this.parseSizeRange(this.chaKan_shu),
      }).then((res) => {
        if (res.code == 1000) {
          this.imgArr = res.data.data;
          this.total = res.data.total;
          this.paginationInput = res.data.limit;
          // this.changing = res.data.show;
          this.sort = res.data.sort;
          this.loading = false;
          this.listNum = {
            download_num: res.data.download_num,
            order_time: res.data.order_time,
            order_total: res.data.order_total,
            total: res.data.total,
          };
        }
      });
    },
    //存储操作数据
    setSessStorage() {
      var outdoor = {};
      outdoor.select = {
        process: this.process,
        is_tag: this.checkInputIs_tag,
        not_tag: this.checkInputNot_tag,
        author: this.authorInput,
        time: this.value2,
        checkInput: this.checkInput,
        source_id: this.frontOrderInput,
        operateLabelInput: this.operateLabelInput,
        radio: this.radio,
        checkInput: this.checkInput,
        labelId: this.labelId,
        sort: this.sort,
      };
      sessionStorage.setItem("outdoor", JSON.stringify(outdoor));
    },

    focusDiyIptEvt() {
      this.focusDiyIpt = true;
    },
    //清除搜索条件
    cleanUpEvt() {
      this.checkInput = "";
      this.behindOrderInput = "";
      this.frontOrderInput = "";
      this.value2 = "";
      this.authorInput = "";
      this.labelId = "";
      this.labelArr = [];
      this.checkInputIs_tag = [];
      this.checkInputNot_tag = [];
      this.operateLabelInput = "";
      this.operateNum.show = false;
      this.selectArr = [];
      this.sortName = "排序方式";
      this.sort = null;
      this.selectAllText = "全选";
      this.selectAllBgColor = "#909399";
      this.banBen = '';
      this.baoMi = '';
      this.pinFen = '';
      this.xiazai_shu = "";
      this.chaKan_shu = "";
      this.shouJia = "";
      this.xiaoShouE = "";
      this.banBen = "";
      this.dengGuang = "";
      this.xiangJi = "";
      this.xuanRan = "";
      this.senLin = "";
      this.Maps_da = "";
      this.Maps_shu = "";
      this.object_shu = "";
      this.shuCai_shu = "";
      this.dingDian_shu = "";
      this.design = "";
      this.value4 = "";
      this.value3 = "";
      this.value1 = "";
      this.zhuShi = "";

      this.compressSize = '';
      this.MAX_daxiao = '';

      for (let i = 1; i <= 2; i++) {
        const refName = `sizePopover${i}`;
        const popover = this.$refs[refName];
        if (popover && typeof popover.clearInputs === 'function') {
          popover.clearInputs();
        }
      }

      if (this.$refs.listComponent) {
        // 调用子组件的方法或直接操作 sortTable
        this.$refs.listComponent.clearSort();
      }

      for (let i = 1; i <= 9; i++) {
        const refName = `compressPopover${i}`;
        const popover = this.$refs[refName];
        if (popover && typeof popover.clear === 'function') {
          popover.clear();
        }
      }

      (this.currentPage1 = 1),
        delay(() => {
          sessionStorage.removeItem("outdoor");
          contentApi({
            process: this.$store.getters.process,
            type: this.type,
            all: "all",
          }).then((res) => {
            if (res.code == 1000) {
              this.imgArr = res.data.data;
              this.total = res.data.total;
              this.paginationInput = res.data.limit;
              this.listNum = {
                download_num: res.data.download_num,
                order_time: res.data.order_time,
                order_total: res.data.order_total,
                total: res.data.total,
              };
            }
          });
        }, 300);
    },
    //本页全选
    selectAllEvt() {
      if (this.selectArr.length === this.imgArr.length) {
        this.imgArr = this.imgArr.map((res) => {
          res.select = false;
          return res;
        });
        this.selectArr = [];
        this.selectAllText = "全选";
        this.selectAllBgColor = "#909399";
      } else {
        this.imgArr = this.imgArr.map((res) => {
          res.select = true;
          return res;
        });
        this.selectArr = this.imgArr.filter((res) => res.select == true);
        this.selectAllText = "取消全选";
        this.selectAllBgColor = "#909399";
      }
    },
    //点击删除  出现弹窗
    delete_Pop() {
      if (this.selectArr.length > 0) {
        this.deleteVisible = true;
      }
    },
    //删除已选中
    deleteEvt() {
      var arr = this.selectArr.map((val) => {
        return val.source_id;
      });
      if (this.$store.getters.process == 5) {
        deleteApi({
          source_ids: arr,
        }).then((res) => {
          if (res.code == 1000) {
            this.imgArr = this.imgArr.map((a) => {
              this.selectArr.map((val) => {
                if (a.source_id == val.source_id) {
                  a = {};
                }
              });
              return a;
            });
            this.deleteVisible = false;
          }
        });
      } else {
        changeImgApi({
          type: this.type,
          process: 5,
          source_ids: arr,
        }).then((res) => {
          if (res.code == 1000) {
            this.imgArr = this.imgArr.map((a) => {
              this.selectArr.map((val) => {
                if (a.source_id == val.source_id) {
                  a = {};
                }
              });
              return a;
            });
            this.deleteVisible = false;
            this.selectArr.length = "0";
          }
        });
      }
    },


  },
};
</script>

<style lang="less" scoped>
@import url("../backHome/js/flex-images.css");
@import url("../style/space.less");
@import url("../style/modelList.less");
@import url("../style/xinjian.less");


/deep/.el-table th.el-table__cell{
  background: #F5F7FA !important;
  padding: 0px !important;
}

/deep/.sousuo .el-dialog__header {
  padding: 0 !important;
}

/deep/.sousuo .el-input__inner {
  height: 38px !important;
  cursor: pointer;
}


.all_input {
  margin-top: 10px;
  margin-left: 15px;
  display: flex;
  align-items: center;

  span {
    width: 55px;
    font-size: 11px;
    text-align: end;
    margin-right: 10px;
  }

  .el-input {
    width: 160px;
    height: 40px;
    border: 1px solid;
    border-radius: 5px;
  }

  .el-select {
    border: 1px solid;
    border-radius: 5px;
  }

  /deep/.el-input__icon {
    line-height: 30px !important;
    cursor: pointer;
  }
}
.all_input_ect {
  /deep/.el-input__icon {
    line-height: 18px !important;
    cursor: pointer;
    margin-left: -15px !important;
  }
}



.dropdown-container {
  position: relative;
  width: 80px;
  cursor: pointer;
  border: 1px solid #e5e5e5;
  border-radius: 5px;
  text-indent: 5px;
  line-height: 5px;
}

.arrow-icon {
  width: 10px;
  height: 10px;
  border-top: 2px solid #e5e5e5;
  border-right: 2px solid #e5e5e5;
  transform: rotate(135deg);
  margin-left: 5px;
  margin-bottom: 5px;
}

.dropdown-trigger {
  cursor: pointer;
  display: inline-block;
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.dropdown-menu {
  position: absolute;
  background-color: white;
  border: 1px solid #ccc;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  z-index: 10;
  margin-top: 30px;
  width: 100px;
  right: 5px;
  /* 调整宽度以适应你的需求 */
}

.menu-item {
  padding: 5px;
  text-align: center;
}

.menu-item:hover {
  background-color: #f0f0f0;
}

.flex-images .item{
  margin:6px !important;
}


/deep/.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
  background-color: #F0F0F0 !important;
  height: 30px !important;
}

/deep/.filter-tree .el-tree-node__content {
  height: 30px !important;
}

/deep/.filter-tree .custom-tree-node {
  margin-right: 15px !important;
}

@media screen and (min-width:0px) and (max-width: 1920px) {
  /deep/.spaceDialog {
    height: 87vh !important;
  }

  .menus_input {
    width: 160px !important;
  }
  .width_ect{
    width: 850px !important;
  }
}
@media screen and (min-width:1921px) and (max-width: 2560px) {
  .width_ect {
    width: 1480px !important;
  }
}
@media screen and (min-width:2561px) and (max-width: 3440px) {
  .width_ect {
    width: 2200px !important;
  }
}
@media screen and (min-width:3441px) and (max-width: 3840px) {
  .width_ect {
    width: 2500px !important;
  }
}
.border_box_e{
  height: 26px;
}
.border_box_e /deep/.el-input__inner{
  height: 26px !important;
}
.border_box_e /deep/.el-input__icon{
  line-height: 26px !important;
}
.border_box_e{
  border: 1px solid #858585 !important;
    border-radius: 5px;
}
.border_box_e /deep/.input_e{
    height: 27px !important;
}

.all_input_e{
  margin-top: 5px !important;
  margin-left: 5px !important;
  display: flex;
  align-items: baseline !important;
}
 .all_input_e /deep/span {
   width:5px !important;
 }
  .all_input_e /deep/.input_e {
    height: 26px !important;
    line-height: 21px !important;
    margin-top: 8px !important;
  }
  .all_input_e /deep/.input_e .el-input__inner{
   height: 26px !important;
  }

    .width_ect {
      overflow-y: scroll;
      /* 启用滚动 */
      height: 50px;
      /* 设置固定高度 */
    }

    /* 隐藏滚动条 */
    .width_ect::-webkit-scrollbar {
      display: none;
    }

    /* 兼容非WebKit浏览器（如Firefox） */
    .width_ect {
      scrollbar-width: none;
      /* Firefox */
    }
    .size_ect{
      height: 30px !important;
    }
    .size_ect /deep/.input_e{
      height: 30px !important;
    }

/deep/.el-scrollbar__wrap {
  overflow-y: scroll !important;
  height: 96% !important;
}



/deep/ .el-input .el-input__clear:hover{
color: #f00 !important;
}
/deep/ .el-date-editor .el-range__close-icon{
color: #f00 !important;
}
/deep/.el-select .el-input .el-icon-circle-close{
  color: #f00 !important;
}
/deep/.sousuo .el-dialog__header {
  padding: 0 !important;
}

/deep/.sousuo .el-input__inner {
  height: 38px !important;
  cursor: pointer;
}



</style>
<style>
.el-picker-panel__sidebar button:nth-child(4) {
  margin-bottom: 10px;
}

.el-picker-panel__shortcut {
  font-size: 12px !important;
}

.your-css-class .el-range-input {
  background-color: #8fc6ff00 !important;
}

.your-css-class_box .el-range-input {
  background-color: #8fc6ff00 !important;
}

::placeholder {
  color: #858585 !important;
}

.border_box {
  border: 1px solid #858585 !important;
  border-radius: 5px
}
</style>



// WEBPACK FOOTER //
// src/model/index.vue